<template>
    <!-- v-if="['A','D','AGENT','N'].find(el=>el==store.state.user.groupe)" -->
    <v-navigation-drawer  >
        <!-- <v-card> -->
            <v-list-item title="Liste de Commandes" subtitle="Négoce"></v-list-item>
            <v-expansion-panels
                v-model="panelOutils"
                 multiple
                >
                <v-expansion-panel v-if="['A','D'].find(el=>el==store.state.user.groupe)">
                    <v-expansion-panel-title>Outils</v-expansion-panel-title>
                    <v-expansion-panel-text>
                        <v-row >
                            <v-col>
                                <v-btn
                                color="primary"
                                @click="triggerFileInput"
                                density="compact"
                                prepend-icon="mdi-file-upload-outline"
                                >
                                </v-btn>
                                <v-file-input
                                    type="file"
                                    ref="fileInput"
                                    style="display: none"
                                    accept=".xlsx,.xls"
                                    @change="handleFileUpload"
                                />
                            </v-col>
                            <!-- :loading="loading" -->
                        </v-row>
                        <!-- <v-row>
                            <v-col>
                                <div  class="input-group input-group-sm mb-3" >
                                    <button style="width: 50px;" @click="getCommandeNegoce(numneg,'test','test')" class="btn btn-outline-secondary" type="button" id="button-addon1">get</button>
                                    <input v-model="numneg"  class="form-control form-control-sm" type="text" >
                                </div>
                            </v-col>
                        </v-row> -->
                    </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>
            <v-divider></v-divider>
            
            <v-expansion-panels
                v-model="panelModeles"
                 multiple
                >
                <v-expansion-panel>
                    <v-expansion-panel-title>Modèles</v-expansion-panel-title>
                    <v-expansion-panel-text>
                         <v-list-item v-for="item in itemsModele"
                            link
                            style="font-size: 0.70rem;"
                            :title="item.title"
                            @click="authentification.type='create_order';
                            model.item=item;
                            getModeleCommande(item);"
                            >
                            <template v-slot:append>
                                <!-- v-if="['A','D'].find(el=>el==store.state.user.groupe)" -->
                                <div class="d-flex align-center gap-2" v-if="['A','D'].find(el=>el==store.state.user.groupe)">
                                    <v-icon 
                                        color="primary" 
                                        @click.stop="authentification.statut=true;
                                        authentification.type='edit_model';
                                        model.item=item"
                                        size="small">
                                        mdi-pencil
                                    </v-icon>
                                    <v-icon 
                                        color="red" 
                                        @click.stop="authentification.statut=true;
                                        authentification.type='delete_model';
                                        model.item=item"
                                        size="small">
                                        mdi-delete
                                    </v-icon>
                                </div>
                            </template>
                        </v-list-item>
                        <v-list-item
                            v-if="['A','D'].find(el=>el==store.state.user.groupe)" 
                            link
                            @click="authentification.statut=true;authentification.type='add_model'">
                            <v-icon icon="mdi-plus" ></v-icon>
                            Ajouter
                        </v-list-item>  
                    </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>
            <v-divider></v-divider>
            <v-expansion-panels
                v-model="panelCommandes"
                 multiple
                >
                <v-expansion-panel>
                    <v-expansion-panel-title>Commandes encours</v-expansion-panel-title>
                    <v-expansion-panel-text>
                        <v-list-item 
                        v-for="(item, i) in negocesCommandesFiltred"
                        :key="i"
                        :value="item"
                        link
                        :title="`${item.tiers?.substring(0,10)}-${item.numero}`"
                        color="primary"
                        @click="authentification.type='edit_order';getCommandeNegoce(item.token);codeMarque=item.code_marque"
                    >
                    <template v-slot:append>
                        <!-- v-if="['A','D'].find(el=>el==store.state.user.groupe)" -->
                        <div class="d-flex align-center gap-2">
                            <v-icon 
                                color="primary" 
                                @click.stop="duplicateCommandeNegoce(item)"
                                size="small">
                                mdi-content-duplicate
                            </v-icon>
                            <!-- <v-icon 
                                color="red" 
                                @click.stop="model.type='delete';model.item=item;authentification.statut=true;authentification.type='delete_model'"
                                size="small">
                                mdi-delete
                            </v-icon> -->
                        </div>
                    </template>
                </v-list-item> 
                    <!-- ;codeMarque=Object.keys(item.articles)[0];getArticles(Array.of(Object.keys(item.articles)[0])) -->
                        
                    </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>
            <v-divider></v-divider>
            <v-expansion-panels
                v-model="panelFilter"
                 multiple
                >
                <v-expansion-panel>
                    <v-expansion-panel-title>Filtres</v-expansion-panel-title>
                    <v-expansion-panel-text>
                        <v-combobox
                            clearable
                            chips
                            multiple
                            label="Saison"
                            :items="store.state.itemsSaisons"
                            v-model="filtre.gp_librepiece3"
                            variant="outlined"
                            density="compact"
                            style="margin: 10px"
                        ></v-combobox>
                        <v-combobox
                            clearable
                            chips
                            multiple
                            label="Marque"
                            :items="['ETRIER','CAMELEON','WOOMEN','BASILIC PEPPER']"
                            item-title="libelle"  
                            item-value="libelle"
                            v-model="filtre.marque"
                            variant="outlined"
                            density="compact"
                            style="margin: 10px;margin-top: -20px"
                        ></v-combobox>
                        <v-combobox
                            clearable     
                            chips
                            label="Client"
                            :items="itemsClient"
                            item-title="t_title"  
                            item-value="t_tiers"
                            v-model="filtre.codeClient"
                            variant="outlined"
                            density="compact"
                            style="margin: 10px;margin-top: -20px"
                        ></v-combobox>
                        <v-combobox
                            clearable    
                            chips
                            label="Agent"
                            :items="commercialItemsFiltred"
                            item-title="libelle"  
                            item-value="code"
                            :disabled="store.state.user.groupe=='AGENT'"
                            v-model="filtre.code_commercial"
                            variant="outlined"
                            density="compact"
                            style="margin: 10px;margin-top: -20px"
                        ></v-combobox>
                        <v-btn @click="getNegocesTable();panelFilter=[]" 
                            variant="outlined"
                            density="compact"
                            color="primary"
                            style="margin: 10px;margin-top: -20px"
                            >get Negoces
                        </v-btn>
                    </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>
            <v-divider></v-divider>
            <v-text-field
                v-model="filtre.rechercher"
                label="Rechercher"
                variant="outlined"
                density="compact"
                style="margin: 10px"
            ></v-text-field>
            <v-chip style="margin-left: 50px;margin-top: -45px" color="secondary">
                {{ negocesTableFiltred.length }} commandes
            </v-chip>
            <v-list style="margin-top: -30px">
                <v-divider></v-divider>
                <v-progress-linear  v-if="waiting"  color="antiquewhite" indeterminate></v-progress-linear>
                <v-list-item 
                    v-for="(item, i) in negocesTableFiltred"
                    :key="i"
                    :value="item"
                    link
                    :title="item.title.title"
                    color="primary"
                    @click="getCmdNeg(item)"
                >
                <!-- color="primary"
                    variant="plain" -->
                    <!-- <button type="button" @click="getCommandeNegoce(item.split('_')[1],'test','test')" 
                        class="btn btn-outline-secondary btn-sm" style="width: 200px;">
                        <span>{{ item.title.title}}</span><br> -->
                        <!-- <span v-if="item.reception.informations" :style="[(item.reception.informations.match(/ref/gmi)||item.reception.etat.match(/ref/gmi))?{'color':'red'}:{'color':'green'}]">
                            {{ `${item.reception.informations?''+item.reception.informations:''}`}}
                        </span>  -->
                    <!-- </button> -->
                </v-list-item>
            </v-list>
        <!-- </v-card>  -->
    </v-navigation-drawer>
  <!-- <div class="container" width="400" v-if="['A','D','AGENT','N'].find(el=>el==store.state.user.groupe)"> -->
    
    <div class="container"  width="400"  >
        <v-progress-linear  v-if="store.state.waiting"  color="grey" indeterminate></v-progress-linear>
        <v-card :elevation="10" style="margin-top:5px;margin-bottom:5px" :class="getElevationClass">    
            <table  cellspacing="0" cellpadding="5">
                <tbody>
                    <tr >
                        <td style="border: 1;" width="300"><img src="https://www.edisac.com/images/article_la/adint.png" alt=""></td>
                        <td style="border: 1;" width="700" >
                            <h6>AD INTERNATIONAL</h6>
                            <p style="margin-top:-10px">Parc d'activité de la verte rue  52 Allée des Prêles</p>
                            <p style="margin-top:-10px">59270 Bailleul - FRANCE</p>
                            <p style="margin-top:-10px">TVA : FR-14-419-363-916</p>
                            <p style="margin-top:-10px">Tel : +33 (0)3 28 42 56 94</p>
                        </td>
                        <td style="border: 1;" width="300">
                            <div><h6>Distributeur de la marque</h6></div>   
                            <div><img :src="`https://www.edisac.com/images/article_la/${negoce.title.logo?negoce.title.logo:'etrier_negoce.png'}`" alt="" width="300"></div> 
                        </td>
                    </tr>
                    
                </tbody>
            </table>  
        </v-card>
         <v-card :elevation="10" style="margin-bottom:5px" :class="getElevationClass">
            <h4 style="text-align: center;">{{ negoce.title.libelle }}</h4>
            <h4 style="text-align: center;"><input v-model="negoce.title.saison"></h4>
            <h6 style="text-align: center;">{{ negoce.fournisseur.date }}</h6>
        </v-card>

        
    <v-expansion-panels
      v-model="panel"
      :readonly="false"
      multiple
    >
      <v-expansion-panel :class="getElevationClass" :elevation="10">
        <v-expansion-panel-title color="#ECECEC">Fourisseur</v-expansion-panel-title>
        <v-expansion-panel-text >
            <v-row>
                <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.modif" v-model="negoce.fournisseur.date" type="date"  label="DATE" variant="outlined" density="compact"
                        style="margin: 10px">
                    </v-text-field>
                </v-col>
               
                <v-col cols="12"  md="2">
                    <v-combobox
                        
                        chips
                        label="CODE CLIENT"
                        :items="itemsClient"
                        item-title="t_tiers"  
                        item-value="t_tiers"
                        v-model="negoce.fournisseur.codeClient"
                        :disabled="authorized.modif"
                        variant="outlined"
                        density="compact"
                        style="margin: 10px"
                    ></v-combobox>
                </v-col>
                 <v-col cols="12"  md="3">
                    <v-combobox
                        
                        chips
                        label="NOM CLIENT"
                        :items="itemsClient"
                        item-title="t_libelle_ville"  
                        item-value="t_tiers"
                        v-model="negoce.fournisseur.nomClient"
                        :disabled="authorized.modif"
                        variant="outlined"
                        density="compact"
                        style="margin: 10px"
                    ></v-combobox>
                </v-col>
                <v-col cols="12"  md="2">
                <!-- <v-text-field :disabled="authorized.modif" v-model="negoce.fournisseur.codeAgent" label="CODE AGENT" variant="outlined" density="compact"
                    style="margin: 10px;">
                </v-text-field> -->
                    <v-combobox
                        
                        chips
                        label="CODE AGENT"
                        :items="commercialItemsFiltred"
                        item-title="code"  
                        item-value="code"
                        v-model="negoce.fournisseur.codeAgent"
                        :disabled="authorized.modif"
                        variant="outlined"
                        density="compact"
                        style="margin: 10px"
                    ></v-combobox>
                </v-col>
                <v-col cols="12"  md="3">
                <!-- <v-text-field :disabled="authorized.modif" v-model="negoce.fournisseur.agent" label="AGENT" variant="outlined" density="compact"
                    style="margin: 10px;">
                </v-text-field> -->
                    <v-combobox
                        
                        chips
                        label="AGENT"
                        :items="commercialItemsFiltred"
                        item-title="title"  
                        item-value="code"
                        v-model="negoce.fournisseur.agent"
                        :disabled="authorized.modif"
                        variant="outlined"
                        density="compact"
                        style="margin: 10px"
                    ></v-combobox>
                </v-col>
               
            </v-row>
            <v-row>
                <v-col cols="12"  md="2">
                    <v-combobox
                        clearable
                        chips
                        label="ETABLISSEMENT"
                        :items="['NEGO','NGEXT']"
                        v-model="negoce.fournisseur.etablissement"
                        :disabled="authorized.modif"
                        variant="outlined"
                        density="compact"
                        style="margin: 10px;margin-top: -40px"
                    ></v-combobox>
                </v-col>
                 <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.modif" v-model="negoce.fournisseur.libCommande" label="LIB COMMANDE" variant="outlined" density="compact"
                    style="margin: 10px;margin-top: -40px">
                    </v-text-field>
                </v-col>
                <v-col cols="12"  md="3">
                    <v-combobox
                        clearable
                        chips
                        label="type commande"
                        :items="[{code:'STD',libelle:'Standard'},{code:'MEP',libelle:'Mise en place'},{code:'REA',libelle:'Réassort'}]"
                        v-model="negoce.fournisseur.type"
                        item-title="libelle"
                        item-value="code"
                        :disabled="authorized.modif"
                        variant="outlined"
                        density="compact"
                        style="margin: 10px;margin-top: -40px"
                    ></v-combobox>
                </v-col>
                <v-col cols="12"  md="2">
                    <v-combobox
                            clearable
                            chips
                            :disabled="authorized.modif"
                            label="Saison"
                            :items="store.state.itemsSaisons"
                            v-model="negoce.fournisseur.saison"
                            variant="outlined"
                            density="compact"
                            style="margin: 10px;margin-top: -40px"
                    ></v-combobox>
                </v-col>
                 
                
            </v-row>            
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel :class="getElevationClass" :elevation="10">
        <v-expansion-panel-title  color="#ECECEC">
           
            <template v-slot:actions="{ expanded }">
                <v-btn 
                @click.stop="newClient?addNewClient('cancel'):addNewClient('create')"
                variant="tonal"
                size="small"
                class="mr-2"
                :disabled="authorized.modif"
                :icon="newClient?'mdi-cancel':'mdi-plus'"
                :color="newClient?'red':''"
                >
                </v-btn>
                <v-btn 
                @click.stop="filtreSingleParams.gp_tiers=negoce.fournisseur.codeClient.t_tiers?negoce.fournisseur.codeClient.t_tiers:negoce.fournisseur.codeClient;dialogueFiltreTiers=true"
                variant="tonal"
                size="small"
                class="mr-2"
                icon="mdi-google-analytics"
                >
                </v-btn>
                <v-icon :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"></v-icon>
            </template>
            
            <!-- Contenu du titre -->
            <span>Client</span>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
            <v-form ref="formClient" v-model="clientValide">
                <v-row>
                    <v-col cols="12" md="2">
                        <v-text-field :disabled="authorized.signe" v-model="negoce.client.enseigne" label="ENSEIGNE *" variant="outlined" density="compact"
                            :rules="[regles.obligatoire]" style="margin: 10px">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field :disabled="authorized.signe" v-model="negoce.client.contact" label="CONTACT *" variant="outlined" density="compact"
                            :rules="[regles.obligatoire]" style="margin: 10px;">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field :disabled="authorized.signe" v-model="negoce.client.raisonSociale" label="RAISON SOCIALE *" variant="outlined" density="compact"
                            :rules="[regles.obligatoire]" style="margin: 10px;">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field :disabled="authorized.signe" v-model="negoce.client.email" label="EMAIL *" type="email" variant="outlined" density="compact"
                            :rules="[regles.obligatoire, regles.email]" style="margin: 10px;">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field :disabled="authorized.signe" v-model="negoce.client.telephone" label="TELEPHONE" type="tel" variant="outlined" density="compact"
                            :rules="[regles.obligatoire,regles.telephone]" style="margin: 10px">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-text-field :disabled="authorized.signe" v-model="negoce.client.tvaSiret" label="TVA OU SIRET" variant="outlined" density="compact"
                            :rules="[regles.tvaSiret]" style="margin: 10px;">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row style="margin-top: -30px">
                    <v-col cols="12" md="2">
                        <v-text-field :disabled="authorized.signe" v-model="negoce.client.dateLivraison" type="date" :min="aujourdhui()" label="DATE DE LIVRAISON *" variant="outlined" density="compact"
                            :rules="[regles.obligatoire, regles.pasDansLePasse]" style="margin: 10px">
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" md="5">
                        <v-text-field prepend-inner-icon="mdi-map-marker" :disabled="authorized.signe" @click="typeAdressToChange='adresseLiv';dialogAdresse={statut:true,persistent:true}" @dblclick="typeAdressToChange='adresseLiv';dialogAdresse={statut:true,persistent:false}" v-model="negoce.client.adresseLiv.adresse" label="ADRESSE DE LIVRAISON *" variant="outlined" density="compact"
                            :rules="[regles.obligatoire]" style="margin: 10px">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="5">
                        <v-text-field prepend-inner-icon="mdi-map-marker" :disabled="authorized.signe" @click="typeAdressToChange='adresseFac';dialogAdresse={statut:true,persistent:true}" @dblclick="typeAdressToChange='adresseFac';dialogAdresse={statut:true,persistent:false}" v-model="negoce.client.adresseFac.adresse" label="ADRESSE DE FACTURATION" variant="outlined" density="compact"
                            style="margin: 10px">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row style="margin-top: -30px">
                    <v-col cols="12" md="3" style="margin: 10px">
                        <v-text-field :disabled="authorized.signe" v-model="negoce.fournisseur.remarque" label="CONSIGNES / REMARQUES" variant="outlined" density="compact"
                            :rules="[regles.max(250)]" counter="250">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" style="margin: 10px">
                        <v-btn color="primary" v-if="newClient" :disabled="!clientValide" @click="createNewClient()">Créer</v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-expansion-panel-text>
        <!-- <v-expansion-panel-text>
             <v-row>
                <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.signe" v-model="negoce.client.enseigne" label="ENSEIGNE" variant="outlined" density="compact"
                        style="margin: 10px">
                    </v-text-field>
                </v-col>
                <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.signe" v-model="negoce.client.contact" label="CONTACT" variant="outlined" density="compact"
                        style="margin: 10px;">
                    </v-text-field>
                </v-col>
                 <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.signe" v-model="negoce.client.raisonSociale" label="RAISON SOCIALE" variant="outlined" density="compact"
                        style="margin: 10px;">
                    </v-text-field>
                </v-col>
                <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.signe" v-model="negoce.client.email" label="EMAIL" variant="outlined" density="compact"
                        style="margin: 10px;">
                    </v-text-field>
                </v-col>
                <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.signe" v-model="negoce.client.telephone" label="TELEPHONE" variant="outlined" density="compact"
                        style="margin: 10px">
                    </v-text-field>
                </v-col>
                <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.signe" v-model="negoce.client.tvaSiret" label="TVA OU SIRET" variant="outlined" density="compact"
                        style="margin: 10px;">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                 <v-col cols="12"  md="2">
                    <v-text-field :disabled="authorized.signe" v-model="negoce.client.dateLivraison" type="date"  label="DATE DE LIVRASION" variant="outlined" density="compact"
                        style="margin: 10px;margin-top: -40px">
                    </v-text-field>
                </v-col>
                
                <v-col cols="12"  md="5">
                    <v-text-field prepend-inner-icon="mdi-map-marker":disabled="authorized.signe" @click="typeAdressToChange='adresseLiv';dialogAdresse={statut:true,persistent:true}" @dblclick="typeAdressToChange='adresseLiv';dialogAdresse={statut:true,persistent:false}" v-model="negoce.client.adresseLiv.adresse" label="ADRESSE DE LIVRAISON *" variant="outlined" density="compact"
                        style="margin: 10px;margin-top: -40px">
                    </v-text-field>
                </v-col>
                <v-col cols="12"  md="5">
                    <v-text-field prepend-inner-icon="mdi-map-marker" :disabled="authorized.signe" @click="typeAdressToChange='adresseFac';dialogAdresse={statut:true,persistent:true}" @dblclick="typeAdressToChange='adresseFac';dialogAdresse={statut:true,persistent:false}" v-model="negoce.client.adresseFac.adresse" label="ADRESSE DE FACTURATION" variant="outlined" density="compact"
                        style="margin: 10px;margin-top: -40px">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12"  md="3" style="margin: 10px;margin-top: -40px">
                    <v-text-field :disabled="authorized.signe" v-model="negoce.fournisseur.remarque" label="CONSIGNES / REMARQUES" variant="outlined" density="compact"
                        >
                    </v-text-field>
                </v-col>
                <v-col cols="12"  md="3" style="margin: 10px;margin-top: -40px">
                   <v-btn color="primary" v-if="newClient" @click="createNewClient()">Créer</v-btn>
                </v-col>
            </v-row>
        </v-expansion-panel-text> -->
      </v-expansion-panel>
      <v-expansion-panel :class="getElevationClass" :elevation="10">
        <v-expansion-panel-title color="#ECECEC">Articles</v-expansion-panel-title>
        <v-expansion-panel-text >
        <div   style="overflow-y: auto;max-height: 900px;;min-height: 300px;">
            <div style="position: sticky;top: 0;z-index: 2">
                <table  style="border: 0.1em  solid">
                    <thead >
                        <tr >   
                            <th width="100" style="border: 0.1em  solid">theme</th> 
                            <th width="100" style="border: 0.1em  solid;">Réf.</th>
                            <th width="100" style="border: 0.1em  solid;">Dés.</th>
                            <th width="100" style="border: 0.1em  solid;">couleur</th>
                            <th width="100" style="border: 0.1em  solid;">taille</th>
                            <th width="75" style="border: 0.1em  solid;" @click="rechercherArticleStatut={statut:false,msg:''};rechercherArticle='';dialogaAjout=true;tab='art'" class="iconAdd"><v-icon class="iconAdd" icon="mdi-store-search" ></v-icon></th>
                            <th width="75" style="border: 0.1em  solid;">Statut</th>
                            <th width="100" style="border: 0.1em  solid;">Livraison</th>
                            <th width="75" style="border: 0.1em  solid;">Qte</th>
                            <th width="100" style="border: 0.1em  solid;">Prix Négoce</th>
                            <th width="100" style="border: 0.1em  solid;">Prix TTC </th>
                            <th width="75" style="border: 0.1em  solid;">Remise</th>
                            <th width="100" style="border: 0.1em  solid;">Totale</th>
                        </tr>
                    </thead>
                </table>
            </div>
           <div  v-for="theme in negoce.articles"><span><v-icon class="iconAdd" icon="mdi-plus" @click="dialogaAjout=true;selectArticle()"></v-icon></span>
            {{theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].theme}}
            
                <div  v-for="(refs, codeRef) in theme"  :key="codeRef" class="bloc-ref">
                    <table  >
                        <tbody style="border: 0.1em  solid;">
                            <tr >
                                <th width="100" rowspan="30" valign="top">
                                    <img style="border: 2px solid grey;padding: 1px;" @click="ouvrirPopUpPhotos(refs[Object.keys(refs)[0]])" v-if="getNonEmptyPhotoNames(refs)" :src="`https://www.edisac.com/images/article_la/${getNonEmptyPhotoNames(refs)}`"  alt="Italian Trulli" max-width="200px" width="100%" height="100%">
                                </th>
                                <th width="100" :disabled="authorized.modif"><v-icon @click="dialogaAjout=true;selectArticle(refs[Object.keys(refs)[0]].code_theme)" v-if="refs[Object.keys(refs)[0]].reference_y2==theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].reference_y2" class="iconAdd" icon="mdi-plus" ></v-icon><span @dblclick="deleteDialog=true;articleToDelete={type:'ref',art:refs[Object.keys(refs)[0]]}">{{ refs[Object.keys(refs)[0]].reference_y2 }}</span></th>
                                <th width="100" >{{ refs[Object.keys(refs)[0]].designation }}</th>
                                <th width="100" height  ="25px" :disabled="authorized.modif" class="iconAdd"><v-icon class="iconAdd" icon="mdi-plus" @click="dialogaAjout=true;selectArticle(refs[Object.keys(refs)[0]].code_theme,refs[Object.keys(refs)[0]].reference_y2)"></v-icon></th>
                                <th colspan="9" ></th>
                            </tr>
                            <tr v-for="article in refs" >
                                <td width="100" height  ="25px"></td>
                                <td width="100" ></td>
                                <td width="100" >
                                    <!-- @click="ouvrirPopUpPhotos(article)"  -->
                                    <span @dblclick="deleteDialog=true;articleToDelete={type:'color',art:article}" style="text-align: center;">
                                        <v-chip 
                                            style="min-width:95px;text-align: center;" size="x-small">{{`${article.couleur}`}}
                                        </v-chip>
                                    </span>
                                </td>
                                <td width="100"  >{{article.taille}}</td>
                                <td width="75" ></td>
                                <td width="75" >
                                    <v-icon :icon="etatStock(article).icon" size="small" :color="etatStock(article).color"></v-icon>
                                    <!-- <select name="stocks" id="stocks"   >
                                        <option >
                                            <v-icon icon="$info" size="small" color="green"></v-icon>
                                        </option>
                                        <option >
                                            <v-icon icon="$info" size="small" color="blue"></v-icon>
                                        </option>
                                    </select> -->
                                </td>
                                <td width="100" style="border: 0.1em  solid;"><input :disabled="authorized.signe" min="0" size="6" style="width: 75%;" type="date" v-model="article.dateLivraison"></td>
                                <td width="75" style="border: 0.1em  solid;"><input :disabled="authorized.signe" min="0" size="6" style="width: 90%;" type="number" v-model="article.qte"></td>
                                <td width="100" style="border: 0.1em  solid;"><input :disabled="authorized.modif" min="0" size="6" style="width: 70%;" type="number" v-model="article.vte_negoce"><span >€</span></td>
                                <td width="100" style="border: 0.1em  solid;"><input :disabled="authorized.modif" min="0" size="6" style="width: 70%;" type="number" v-model="article.vte_euro"><span >€</span></td>
                                <td width="75" style="border: 0.1em  solid;"><input :disabled="authorized.modif" min="0" size="6" style="width: 70%;" type="number" v-model="article.remise"><span >%</span></td>
                                <td width="100" style="border: 0.1em  solid;"><input min="0" size="6" style="width: 70%;" type="number" :value="(article.vte_negoce*article.qte*(1-article.remise/100)).toFixed(2)" disabled><span > €</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            <div>
                <table>
                    <tbody style="border: 0.1em  solid;">
                        <tr>
                            <td width="650"></td>
                            <th width="100" style="text-align: right; ">Sous Totale</th>
                            <th width="75">{{totaleQteCde(theme)}}</th>
                            <th width="275"></th>
                            <th width="100" ><input size="6" type="text" style="width: 70px;" disabled :value="totaleHtCde(theme)"><span >€</span></th>
                        </tr>
                    </tbody>
                </table>
            </div>  
           </div>
             </div>
            <div>
                <table  cellspacing="0" cellpadding="10">
                    <tbody style="border: 0.1em  solid;">
                        <tr>
                            <td width="100px" rowspan="5" colspan="6" style="border: 0.1em  solid;max-height:200px ;" class="chart-container">
                                <!-- <Pie   :data="chartData" :options="chartOptions" /> -->
                                <FrepPieChart @click="statDialog=true" :frep="negoce" :statDialog="statDialog" />
                            </td>
                            <td colspan="6" height="20">  </td> 
                        </tr>
                        <tr >   
                            <td width="100px"></td>
                            <th width="100px">TOTAL QUANTITES :</th>
                            <th width="100px">{{ totaleHtCde2(negoce.articles).qte}}</th>
                            <th width="100px" style="text-align: right; ">TOTAL CDE HT :</th>
                            <th width="100px">
                                <input min="0" :disabled="authorized.modif" disabled size="6" style="width: 70px;" type="number" :value="totaleHtCde2(negoce.articles).totale"><span >   €</span>
                            </th>
                        </tr>
                        <tr >   
                            <td width="100px"></td>
                            <th width="100px"></th>
                            <th width="100px"></th>
                            <th width="200px" style="text-align: right; ">FRAIS DE PORT:</th>
                            <th width="100px" > <span>{{ fraisPort }}</span><span> €</span>
                                <!-- <input min="0"  size="6" style="width: 70px;" type="number" v-model="negoce.fraisPort">€ -->
                            </th>
                        </tr>
                        <tr >   
                            <td width="100px"></td>
                            <th width="100px"></th>
                            <th width="100px"></th>
                            <th width="200px" style="text-align: right; ">REMISE PIED:</th>
                            <th width="100px" >
                                <input min="0"  size="6" style="width: 70px;" type="number" v-model="negoce.remise_pied">%
                            </th>
                        </tr>
                        <tr >   
                            <td width="100px"></td>
                            <th width="100px" ></th>
                            <th width="100px" ></th>
                            <th width="100px" style="text-align: right; ">TOTAL CDE HT :</th>
                            <th width="100px" ><input min="0" disabled size="6" style="width: 70px;" type="number" :value="Number(totaleHtCde2(negoce.articles).totale) * Number(1 - negoce.remise_pied/100) + Number(negoce.fraisPort)"><span >   €</span></th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <table  cellspacing="0" cellpadding="10">
                    <tbody >
                        <tr>
                            <td width="600px" style="text-align: center ;border: 0.1em  solid;">CONDITIONS COMMERCIALES NEGOCE - 2026 France métropolitaine (hors Corse) et Belgique <a href='https://www.edisac.com/second-life-cgv-t16037/' target="_blank">voir</a></td>
                            <td width="100px"></td>
                            <td width="500px"  >Je reconnais avoir reçu et pris connaissance des CONDITIONS GENERALES DE VENTE </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <table  cellspacing="0" cellpadding="10">
                    <tbody >
                         <tr>
                            <td width="100px"> </td>
                            <td width="100px"> </td>
                            <td width="100px"> </td>
                            <td width="100px"> </td>
                            <td width="100px"> </td>
                            <td width="100px"> </td>
                            <td width="100px"> </td>
                            <td  width="500px"  rowspan="3">
                                <SignatureDropbox v-if="negoce.numero&&negoce.file&&negoce.client.email&&negoce.client.raisonSociale"
                                    :signer-email="negoce.client.email"
                                    :signer-name="negoce.client.raisonSociale"
                                    client-id="6e3ac0a3fe8218ee0e6e81b0b7fce125"
                                    :numero="`${negoce.numero}`" 
                                    :file="negoce.file"
                                    @signed="onSigned"
                                    @cancelled="onCancelled"
                                    @error="onError"
                                />
                                <!-- <v-card :elevation="10" v-if="negoce.signature.exist" >
                                    <v-card v-if="negoce.signature.exist"  >
                                        <img :src="negoce.signature.link" ></img>
                                    </v-card>
                                </v-card>
                                <v-card :elevation="10" v-if="!negoce.signature.exist">
                                    <Vue3Signature   :disabled="['AGENT','N'].find(el=>el==store.state.user.groupe)?true:false"  ref="signature1" :sigOption="state.option" :w="'500px'" :h="'100px'">
                                    </Vue3Signature>
                                </v-card> -->
                            </td>
                        </tr> 
                        <tr>
                            <td width="100px" height="20" style="border: 0.1em  solid;" >coef 2.8</td>
                            <td width="100px" style="border: 0.1em  solid;" >MIN COMMANDE MEP</td>
                            <td width="100px" style="border: 0.1em  solid;" >FRANCO MEP</td>
                            <td width="100px" style="border: 0.1em  solid;" >MIN REA</td>
                            <td width="100px" style="border: 0.1em  solid;" >FRANCO REA</td>
                            <td width="100px" style="border: 0.1em  solid;" >PORT</td>
                            <td width="100px"> </td>
                        </tr>
                        <tr>
                            <td width="100px" height="20" style="border: 0.1em  solid;" >MAROQUINERIES</td>
                            <td width="100px" style="border: 0.1em  solid;" >500 € HT</td>
                            <td width="100px" style="border: 0.1em  solid;" >1000 € HT</td>
                            <td width="100px" style="border: 0.1em  solid;" >250 € HT</td>
                            <td width="100px" style="border: 0.1em  solid;" >250 € HT</td>
                            <td width="100px" style="border: 0.1em  solid;" >20 € HT</td>
                            <td width="100px"> </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="margin-bottom: 20px;">
                <table  cellspacing="0" cellpadding="10">
                    <tbody >
                        <tr>
                            <td width="600px"></td>
                            <td width="100px"></td>
                            <td width="500px">
                                <v-bottom-sheet  inset>
                                    <template v-slot:activator="{ props: activatorProps }">
                                        <v-btn v-if="!negoce.signature.exist&&store.state.user.groupe=='N'"  style="margin: px;" v-bind="activatorProps" @click="save('./image.jpeg')" text="Signer"></v-btn>
                                    </template>
                                    <v-card
                                        title="Signature"
                                        text="Votre signature a été pris en compte!"
                                    ></v-card>
                                </v-bottom-sheet>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        <v-card v-if="['A','D','AGENT','N'].find(el=>el==store.state.user.groupe)" class="actions-card">
            <v-card-actions class="justify-center">
                <v-btn color="success" size="large"  
                    :disabled="store.state.user.groupe=='N'"
                    :loading="loading" 
                    @click="authentification.type='validation';authentification.statut=true" 
                >
                <v-icon icon="mdi-check" class="mr-2"></v-icon>
                    Valider la Commande
                </v-btn>
                <v-btn v-if="store.state.user.groupe!='N'" @click="nouvelleCommande()" color="warning">
                    <v-icon icon="mdi-autorenew" class="mr-2"></v-icon>
                    Nouvelle Commande</v-btn>
                <v-btn @click="EnvoyerCommandeNegoce()" v-if="['A','D','AGENT'].find(el=>el==store.state.user.groupe)" color="primary">
                    <v-icon icon="mdi-email" class="mr-2"></v-icon>
                    Envoyer</v-btn>
                <v-btn @click="ExporterCommandeNegoce()" v-if="['A','D'].find(el=>el==store.state.user.groupe)"   color="green">
                <v-icon icon="mdi-export" class="mr-2"></v-icon>
                    Exporter</v-btn>
            </v-card-actions>
        </v-card>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <div v-if="!authorized.modif" class="text-center" >
      <v-dialog  v-model="dialogaAjout" width="auto" >
        <v-card  prepend-icon="mdi-plus" 
        :text="tab=='art'?`Veulliez saisir l'article à ajouter`:(tab=='three'?`Veulliez choisir le thème à ajouter`:(tab=='two'?`Veulliez choisir la référence à ajouter`:`Veuillez saisir la qté de chaque couleur`))"
        title="Ajout Articles"
        >
        <v-card >
            <v-card-text >
            <div v-if="tab=='art'" class="input-group input-group-sm mb-3">
                <input size="5"  v-model="rechercherArticle"  class="form-control form-control-sm" type="text" :style="[rechercherArticleStatut.statut?{'color':'red'}:{}]"> 
            </div>
            <div v-if="tab!='art'" class="input-group input-group-sm mb-3" height="10px">
                <input size="5"  v-model="rechercher"  class="form-control form-control-sm" type="text" >
                <div v-if="tab=='one'">
                    <input v-model="EAN13Choice" style="margin: 0.4rem;" type="checkbox" id="scales" name="scales" checked />
                    <label style="font:1rem Fira Sans,sans-serif;" for="scales">ean13</label>
                </div>
            </div>
            <div v-if="rechercherArticleStatut.statut" style="text-align: center;color: red;">
                <p>{{ rechercherArticleStatut.msg }}</p>
            </div>
            <v-tabs-window v-model="tab" >
                <v-tabs-window-item value="one">
                    <v-card class="scroll-box">  
                        <table height="auto">
                            <tbody>
                                <tr v-for="color in articleToAddTabFilter" >
                                    <td  >
                                        
                                        <div class="input-group input-group-sm mb-3">
                                            <button style="width: 150px;" @click="color.qte++" class="btn btn-outline-secondary" type="button" id="button-addon1">{{ `${color.taille?color.code_couleur+"-"+color.couleur+"-"+color.taille:color.code_couleur+"-"+color.couleur}` }}</button>
                                            <input  v-if="EAN13Choice" :style="[gererateEAN13(color.ean13_y2).erreur?{'color':'red','width': '120px'}:{'color':'green','width': '120px'}]" v-model="color.ean13_y2"  class="form-control form-control-sm" type="text" ></input>
                                            <input  style="width: 70px;" v-model="color.qte"  min="0" class="form-control form-control-sm" type="number" ></input>
                                            <span ><v-icon style="margin-top: 8px;margin-left: 8px;" :icon="etatStock(color).icon" size="small" :color="etatStock(color).color"></v-icon></span>
                                        </div>
                                        <p  v-if="EAN13Choice&&gererateEAN13(color.ean13_y2).erreur" style="color:red;height: 2px;text-align: center;">Vérifiez le code ean13</p>    
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-card>   
                </v-tabs-window-item>
                <v-tabs-window-item value="two" scrollable>
                   <v-card class="scroll-box">
                    <table height="auto">
                        <tbody>
                            <tr v-for="ref in articleToAddTabFilter">
                                <td  width="300" >
                                    
                                    <div class="input-group input-group-sm mb-3">
                                        <button style="width: 150px;" @click="tab='one';selectArticle(ref.theme,ref.code )" class="btn btn-outline-secondary" type="button" id="button-addon1">{{ ref.code  }}</button>
                                        <input disabled v-model="ref.libelle"  class="form-control form-control-sm" type="text" >
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                   </v-card> 
                </v-tabs-window-item>
                <v-tabs-window-item value="three" height="400">
                    <v-card class="scroll-box">
                        <div v-for="theme in articleToAddTabFilter" style="margin-top: 1px;">
                            <div  class="input-group input-group-sm mb-3">
                                <button style="width: 150px;" @click="tab='one';selectArticle(theme.code)" class="btn btn-outline-secondary" type="button" id="button-addon1">{{ theme.code  }}</button>
                                <input disabled="true" v-model="theme.libelle"  class="form-control form-control-sm" type="text" >
                            </div>
                        </div>
                    </v-card>
                </v-tabs-window-item>
            </v-tabs-window>
            </v-card-text>
        </v-card>
        <template v-slot:actions>
            <v-btn class="ms-auto" text="Annuler" @click="dialogaAjout = false" style="text-align: left;"></v-btn>
            <v-btn v-if="tab!='art'" class="ms-auto" text="Ajouter" @click="addArticle();dialogaAjout = false"></v-btn>
            <v-btn v-if="tab=='art'" class="ms-auto" text="Ajouter" @click="getArticle()"></v-btn>
        </template>
        </v-card>
      </v-dialog>
    </div> 
    <div class="text-center pa-4">
      <v-dialog
        v-model="deleteDialog"
        width="auto"
      >
        <v-card
          max-width="400"
          prepend-icon="$error"
          :text="`${articleToDelete.type=='color'?'Vous voulez vraiment supprimer la couleur '+articleToDelete.art.couleur+' ?':'Vous voulez vraiment supprimer la référence '+articleToDelete.art.reference_y2+' ?'}`"
          title="Suppression"
        >
          <template v-slot:actions>
            <v-card-actions>
                <v-btn
                    text="Annuler"
                    @click="deleteDialog = false"
                    variant="plain"
                    color="green"
                ></v-btn>
                <v-btn
                    color="red"
                    text="Supprimer"
                    @click="supprimer();deleteDialog = false"
                    variant="plain"
                ></v-btn>
            </v-card-actions>  
          </template>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center pa-4">
      <v-dialog
        v-model="imageDialog"
        width="600"
      >
        <v-card width="600">
            <v-img
                width="600"
                cover
                :src="srcImage"
            ></v-img>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center pa-4">
      <v-dialog
          v-model="commandeNotExist.exist"
          width="auto"
      >
          <v-card
          max-width="400"
          prepend-icon="$error"
          :text="commandeNotExist.new=='rien'?`La commande numéro ${commandeNotExist.numero} n'existe pas`:(commandeNotExist.new=='new'?`La commande numéro ${commandeNotExist.numero} a été créé`:`La commande numéro ${commandeNotExist.numero} a été importé`)"
          title="Commande pas trouvé"
          >
          <template v-slot:actions>
              <v-btn
              class="ms-auto"
              text="Ok"
              @click="commandeNotExist.exist = false"
              ></v-btn>
          </template>
          </v-card>
      </v-dialog>
    </div>
    <div class="text-center pa-4">
        <v-dialog
            v-model="dialogEmail"
            width="auto"
        >
            <v-card
            max-width="400"
            prepend-icon="mdi-update"
            :text="`La commande a été renvoyé`"
            title="Email envoyé"
            >
            <template v-slot:actions>
                <v-btn
                class="ms-auto"
                text="Ok"
                @click="dialogEmail = false"
                ></v-btn>
            </template>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-center pa-4">
      <v-dialog
          v-model="authentification.statut"
          width="auto"
      >
          <v-card
          max-width="400"
          prepend-icon="mdi-account-check"
          text="Veuillez saisir votre mot de passe"
          title="Vérification"
          >
          <v-spacer></v-spacer>
          <v-card-actions >
            <input 
            type="text" class="form-control" placeholder="mot de passe" aria-label="mot de passe" aria-describedby="basic-addon2" v-model="mdpSaisie">
            <v-btn
            text="Annuler"
            @click="authentification.statut = false"
            color="warning"
            ></v-btn>
            <v-btn
            text="Valider"
            @click="checkingLogIn()"
            :disabled="mdpSaisie!=''?false:true"
            color="success"
            ></v-btn>
            
            </v-card-actions>
            <small v-if="message" style="color:red;margin-left: 0.5em;text-align: center;" >{{message}}</small>
          </v-card>
      </v-dialog>
    </div>
    <div >
      <v-dialog
          v-model="newModele.dialog"
          width="600px"
      >
          <v-card
          
          prepend-icon="mdi-account-check"
          text="Veuillez saisir la marque et la saison"
          title="Ajout Modèle"
          >
          <v-spacer></v-spacer>
          <v-card-text>
            <v-row>
                <v-col cols="12"  md="4">
                    <v-combobox clearable    chips    
                        label="Marque"
                        :items="[{code:'731',label:'ETRIER'},{code:'742',label:'WOOMEN'},{code:'737',label:'CAMELEON'}]"
                        item-title="label"  
                        item-value="code"
                      
                        v-model="newModele.marque"
                        variant="outlined" density="compact"
                    ></v-combobox>
                </v-col>
                <v-col cols="12"  md="4">
                    <v-text-field
                        density="compact"
                        v-model="newModele.saison"
                        label="Saison"
                        variant="outlined"
                        :rules="saisonRules"
                        placeholder="Ex: H25 ou E25"
                        counter
                        maxlength="3"
                        required
                    ></v-text-field>
                </v-col>
                <v-col cols="12"  md="4">
                    <v-text-field
                        density="compact"
                        v-model="newModele.remarque"
                        label="Remarque"
                        variant="outlined"
                    ></v-text-field>
                </v-col>
            </v-row> 
            </v-card-text>
          <v-card-actions >
            <v-btn
            text="Annuler"
            @click="newModele.dialog = false"
            color="warning"
            ></v-btn>
            <v-btn
            text="Valider"
            @click="setNewModeleNegoce()"
            :disabled="!newModele.saison||!newModele.marque?true:false"
            color="success"
            ></v-btn>
            
            </v-card-actions>
          </v-card>
      </v-dialog>
    </div>
    
    <div  >
        <v-dialog
            v-model="dialogAdresse.statut"
            :persistent="dialogAdresse.persistent"
           max-width="600px" 
        >
            <v-card
            title="Adresse"
            >
                <v-card-text>
                    <v-row>
                        <v-col cols="12"  md="6">
                            <v-text-field  density="compact" v-model="negoce.client[typeAdressToChange].libelleAdresse" label="Libelle" variant="outlined"></v-text-field>
                        </v-col>
                    </v-row> 
                    <v-row>
                        <v-col>
                            <v-text-field  density="compact" v-model="negoce.client[typeAdressToChange].adresse1" label="Adresse 1" variant="outlined"></v-text-field>
                        </v-col>
                    </v-row> 
                    <v-row>
                        <v-col>
                            <v-text-field  density="compact" v-model="negoce.client[typeAdressToChange].adresse2" label="Adresse 2" variant="outlined"></v-text-field>
                        </v-col>
                    </v-row> 
                    <v-row>
                        <v-col>
                            <v-text-field density="compact" v-model="negoce.client[typeAdressToChange].codePostal" label="Code Postal" variant="outlined"></v-text-field>
                        </v-col> 
                        <v-col>
                            <v-text-field density="compact" v-model="negoce.client[typeAdressToChange].ville" label="Ville" variant="outlined"></v-text-field>
                        </v-col> 
                        <v-col>
                            <!-- <v-text-field density="compact" v-model="negoce.client[typeAdressToChange].pays" label="Pays" variant="outlined"></v-text-field> -->
                             <v-combobox 
                                chips    
                                label="Pays"
                                :items="store.state.countries"
                                item-title="libelle"  
                                item-value="code"
                                v-model="negoce.client[typeAdressToChange].pays"
                                variant="outlined" density="compact"
                            ></v-combobox>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-spacer></v-spacer>
            <v-card-actions >
                <v-btn
                    text="Annuler"
                    @click="dialogAdresse.persistent?changeAdresse():dialogAdresse.statut = false"
                    color="warning"
                ></v-btn>
                <v-btn
                    text="Valider"
                    @click="changeAdresse()"
                    color="success"
                ></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>  
    <v-dialog
        v-model="dialogStatsTiers"
        width="auto"
        persistent
    >
        <v-card
        prepend-icon="'mdi-google-analytics"
        :title="`${statsTable[0].gp_tiers? 'Statistiques Client : '+statsTable[0].gp_tiers:'Veuillez patienter'}` "
        >
        <v-card-text>
            <div width="900px">
                <table>
                    <tbody>
                        <tr>
                            <!-- <v-btn density="compact" @click="statsToGet='all';dialogueFiltre=true" icon="mdi-plus" style="margin-top: 15px;" ></v-btn> -->
                            <td width="150px">
                                <v-select  
                                variant="outlined"
                                :items="['gl_naturepieceg','gl_etablissement','numero','gp_tiers','code_commercial','marque','theme','rayon','famille','sousfamille','ga_codearticle','couleur','codebarre','gp_librepiece1','gp_librepiece3','gl_collection','annee']"
                                density="compact"
                                label="Axe X"
                                v-model="axe.x"
                                ></v-select>
                            </td>
                            <td width="150px" style="margin-left: 10px;">
                                <v-select
                                    variant="outlined"
                                    :items="['gl_qtestock','gl_totalht']"
                                    density="compact"
                                    label="Axe Y"
                                    v-model="axe.y"
                                ></v-select>
                            </td>
                            <td width="70px">
                                <v-switch  v-model="isBarChart" :label="isBarChart ? '📊' : '🥧'"></v-switch>
                            </td>
                            <td width="70px">
                                <v-switch  v-model="axe.showPercent" :label="axe.showPercent ? '%' : '€'"></v-switch>
                            </td>
                            
                            <td width="160px" style="margin-left: 10px;"> 
                                <v-text-field :disabled="authorized.modif" density="compact" v-model="filtreSingleParams.gp_tiers" label="Code Client" type="text" variant="outlined" clearable></v-text-field>
                            </td>
                            <td width="160px" style="margin-left:10px;">
                                <v-combobox clearable    chips    multiple
                                    label="Saison"
                                    :items="['SAIH22','SAIH23','SAIH24','SAIH25','SAIH26','SAIE22','SAIE23','SAIE24','SAIE25','SAIE26']"
                                    v-model="filtreSingleParams.gp_librepiece3"
                                    variant="outlined" density="compact"
                                ></v-combobox>
                            </td>
                           
                            <v-btn style="margin-top: 15px;margin-left: 10px;"
                                density="compact"
                                :loading="loading"
                                :disabled="!filtreSingleParams.gp_tiers&&!filtreSingleParams.gp_librepiece3"
                                @click="loading=true;dialogErreur=false;getStatsTiers('rechercherNegoces',filtreSingleParams.gp_tiers)"
                                aria-label="Refresh"
                                icon="mdi-refresh"
                            ></v-btn>
                            <v-btn  density="compact" style="margin-top: 15px;;margin-left: 10px;" color="green" @click="exportToExcel(statsTable)" >
                                <v-icon icon="mdi-file-excel"></v-icon>
                            </v-btn>
                            <!-- </td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
            <div   class="chart-chart-container-pie">
                <div v-if="!dialogErreur" style="height: 400px">
                    <Pie  v-if="!isBarChart" :data="chartDataStats" :options="pieOptions" />
                    <Bar  v-if="isBarChart" :data="chartDataStats" :options="barOptions" />
                </div>
                
                <div v-if="dialogErreur" class="loading-content" width="400px">
                    <p class="mt-4 text-h6">Pas de données...</p>
                    <p class="text-caption">Modifier le filtre</p>
                    <!-- <template v-slot:actions> -->
                
                    <!-- </template> -->
                </div>
            </div>
            <div  class="chart-chart-container-pie">
                <NegoceTable
                :mockData="statsTable">

                </NegoceTable>
            </div>
        </v-card-text>
        <v-card-actions>
            <v-btn
                class="ms-auto"
                text="Ok"
                @click="dialogStatsTiers = false"
            ></v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
    <div  class="text-center" >
        <!-- max-width="600" width="600" -->
        <v-dialog v-model="dialogueFiltreTiers" width="600"  :persistent="loading">
            <v-card  prepend-icon="mdi-shopping-search" 
            text="Veillez changer les dates"
            title="Filtrage"
            >
        
            <v-card-text >
                    <v-row  style="margin-top: 10px">
                        <v-col cols="12" md="4" sm="12">
                            <v-text-field :disabled="authorized.modif" clearable type="text" label="Code Client" style="margin-top: -40px" v-model="filtreSingleParams.gp_tiers" variant="outlined" density="compact"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" sm="12">
                            <v-text-field clearable type="text" :disabled="store.state.user.groupe=='AGENT'"
                            label="Commercial" style="margin-top: -40px" v-model="filtreSingleParams.code_commercial" variant="outlined" density="compact"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" sm="12">
                             <v-combobox clearable    chips    multiple
                                label="Marque"
                                :items="['ETRIER','WOOMEN','CAMELEON']"
                                v-model="filtreSingleParams.marque"
                                variant="outlined" density="compact"
                                style="margin-top: -40px"
                            ></v-combobox>
                        </v-col>
                    </v-row>  
                    <v-row>
                        <v-col cols="12" md="4" sm="12">
                            <v-combobox clearable    chips    multiple
                                label="Nature"
                                :items="['CC - Commande','BLC - Livraison','AVS - Avoir Stock','AVC - Avoir Client']"
                                v-model="filtreSingleParams.gl_naturepieceg"
                                variant="outlined" density="compact"
                                style="margin-top: -40px"
                            ></v-combobox>
                        </v-col>
                        <v-col cols="12" md="4" sm="12">
                            <v-combobox clearable    chips
                                label="Type"
                                :items="['CATSTD','CATREA']"
                                v-model="filtreSingleParams.gp_librepiece1"
                                variant="outlined" density="compact"
                                style="margin-top: -40px"
                            ></v-combobox>
                        </v-col>
                        <v-col cols="12" md="4" sm="12">
                            <v-combobox clearable    chips    multiple
                                label="Saison"
                                :items="['SAIH22','SAIH23','SAIH24','SAIH25','SAIH26','SAIE22','SAIE23','SAIE24','SAIE25','SAIE26']"
                                v-model="filtreSingleParams.gp_librepiece3"
                                variant="outlined" density="compact"
                                style="margin-top: -40px"
                            ></v-combobox>
                        </v-col>
                    </v-row>
                     
                </v-card-text>
                <v-card-actions>
                    <div class="d-flex justify-space-between w-100">
                        <v-btn 
                            text="Annuler"
                            @click="loading=false;dialogueFiltreTiers=false"
                            color="warning"
                        ></v-btn>
                        <v-btn 
                            text="Lancer la recherche"
                            :loading="loading"
                            :disabled="loading"
                            @click="loading=true;dialogErreur=false;getStatsTiers('rechercherNegoces',filtreSingleParams.gp_tiers)"
                            color="primary"
                        ></v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <PhotosFripe v-if="popupVisible"
            v-model="popupVisible"
            :article="articlePhoto"
            :photosTab="photosFripe"
        ></PhotosFripe>
    </div>
    <div class="text-center pa-4">
      <v-dialog
        v-model="statDialog"
        width="600"
      >
        <v-card>
            <FrepPieChartDialog :frep="negoce" />
        </v-card>
      </v-dialog>
    </div>

</template>
<script setup>
    import { reactive, onMounted, ref, computed, watch } from 'vue'
    import axios from 'axios'
    import store from './store'
    import router from './router'
    import NegoceTable from './components/NegoceTable.vue'
    import PhotosFripe from './components/PhotosFripe.vue'
    import SignatureDropbox from './components/SignatureDropbox.vue';
    import * as XLSX from 'xlsx';
    import {
    Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        ArcElement,
        BarElement,
        CategoryScale,
        LinearScale 
    } from 'chart.js'
    import { Pie, Bar } from 'vue-chartjs'
    import { useRoute, onBeforeRouteUpdate } from 'vue-router'
    import FrepPieChart from './components/FrepPieChart.vue'
    import FrepPieChartDialog from './components/FrepPieChartDialog.vue'
    let deleteDialog=ref(false)
    let srcImage=ref()
    let imageDialog=ref(false)
    const zoom = ref(600)
    let loading = ref(false)
    let dialogStatsTiers=ref(false)
    let authentification=ref({type:'',statut:false})
    const isBarChart = ref(false)
    let dialogueFiltreTiers=ref(false)
    let statDialog=ref(false)
    let commercialItems=ref([])
    let filtre=ref({
        gl_naturepieceg:['CC'],
        gp_librepiece3:null,
        marque:null,
        code_commercial: store.state.user.groupe=='AGENT'?store.state.user.username.toUpperCase():null,
        codeClient:'FR51CAC372',
        rechercher:null
    })
    function onSigned() {
        console.log('✅ Document signé');
    // Mettre à jour le statut dans votre app
    }

    function onCancelled() {
        console.log('❌ Signature annulée');
    }

    function onError(err) {
        console.error('Erreur:', err);
    }
    let axe=ref({
        x:'gp_librepiece3',
        y:'gl_qtestock',
        showPercent:false
    })
    let filtreSingleParams=ref({
        gp_tiers : null,
        gl_naturepieceg : null,
        code_commercial: store.state.user.groupe=='AGENT'?store.state.user.username.toUpperCase():null,
        gp_librepiece1 : null,
        gp_librepiece3 : null,
        date_debut : null,
        date_fin : null,
        date_liv_debut : null,
        date_liv_fin : null,
        marque : null,
        rayon : null,
        acheteur : null,
        codepole : null,
        limit : null,
        offset : 0
    })
    // let commercialItems=ref([
        // {code:'COMMM'   ,libelle:'COMMERCIAL'},
        // {code:'REPBAS13',libelle:'2R ACCESS'},
        // {code:'REPBAS15',libelle:'TEWES'},
        // {code:'REPBAS22',libelle:'GEORGELIN'},
        // {code:'REPCAM01',libelle:'VAN MEIRSSCHE'},
        // {code:'REPCAM03',libelle:'GEORGELIN '},
        // {code:'REPCAM05',libelle:'TEWES'},
        // {code:'REPCAM06',libelle:'BUSOLIN'},
        // {code:'REPCAM07',libelle:'YEUM'},
        // {code:'REPCAM11',libelle:'2R ACCESS DISTRIBUTION'},
        // {code:'REPCAM21',libelle:'INTERNE'},
        // {code:'REPETR10',libelle:'VAN GOMPEL'},
        // {code:'REPETR16',libelle:'GEORGELIN'},
        // {code:'REPETR17',libelle:'TEWES'},
        // {code:'REPETR18',libelle:'2R ACCESS DISTRIBUTION'},
        // {code:'REPETR20',libelle:'INTERNE'},
        // {code:'REPETR21',libelle:'SERVANT'},
        // {code:'REPETR24',libelle:'MORET'},
        // {code:'REPWOO02',libelle:'SILVAN'},
        // {code:'REPWOO04',libelle:'GEORGELIN'},
        // {code:'REPWOO08',libelle:'YEUM'},
        // {code:'REPWOO09',libelle:'VAN GOMPEL'},
        // {code:'REPWOO12',libelle:'TEWES'},
        // {code:'REPWOO14',libelle:'2R ACCESS DISTRIBUTION'},
        // {code:'REPWOO19',libelle:'INTERNE'},
        // {code:'REPWOO23',libelle:'SERVANT'},
        // {code:'REPWOO25',libelle:'MORET'}
    // ])
    let commandeNotExist=ref({exist:false,numero:''})
    let EAN13Choice=ref(false)
    let typeAdressToChange=ref('')
    function changeAdresse(){
        negoce.value.client[typeAdressToChange.value].adresse=`${negoce.value.client[typeAdressToChange.value].adresse1} - ${negoce.value.client[typeAdressToChange.value].codePostal} - ${negoce.value.client[typeAdressToChange.value].ville} - ${negoce.value.client[typeAdressToChange.value].pays.code?negoce.value.client[typeAdressToChange.value].pays.libelle:negoce.value.client[typeAdressToChange.value].pays}`
        dialogAdresse.value.statut = false
    }
    const route = useRoute()
    const id = ref(null)
    const num = ref(null)
    const token = ref(null)
    const currentUrl = ref('')
    const error = ref('')
    let message=ref()
    let dialogEmail=ref(false)
    let mdpSaisie=ref('marwen/001')
    let dialogErreur=ref(false)
    defineProps({
        id: String,
        num: [String, Number],
        token: String,
    })
    const loadParams = () => {
        console.log(route.params)
        if(route.params&&route.params.token){
            try {
                
                token.value = route.params.token
                currentUrl.value = window.location.href
                
                store.commit('addUser',{groupe:'N'})
                getCommandeNegoce (token.value)
                // }
                if (!token.value) {
                    error.value = 'Paramètres manquants'
                }else{
                    // router.replace({ path: '/login' })
                    return
                }
            } catch (err) {
                error.value = err.message
            }
        }
    }
    let dialogAdresse=ref({
        statut:false
    })
        //
    let negoce=ref({
        title:{
            libelle:'BON DE COMMANDE',
            saison:'SPRING - SUMMER 2026',
            dateModif:'2025-09-25',
            logo:'etrier_negoce.png'
        },
        fournisseur:{
            date:'2025-10-01',
            nomClient:'Test',
            codeClient:'RE97SAC763',
            agent:'agent_test',
            codeAgent:'code_agent',
            libCommande:'testcommande',
            etablissement:'NEGO',
            type:'MEP'
        },
        client:{
            enseigne:'enseigne',
            raisonSociale:'test',
            tvaSiret:'TVA_TEST',
            dateLivraison:'2025-10-15',
            adresseLiv:{
                adresse:'30 rue national - 59270 - Bailleul - France',
                libelleAdresse:'adresse Liv',
                adresse1: '30 rue national',
                adresse2: 'test',
                codePostal: '59270',
                ville: 'Bailleul',
                pays: 'France'
            },
            adresseFac:{
                adresse:'30 rue national - 59270 - Bailleul - France',
                libelleAdresse:'adresse fact',
                adresse1: '30 rue national',
                adresse2: 'test',
                codePostal: '59270',
                ville: 'Bailleul',
                pays: 'France'
            },
            contact:'contact_test',
            email:'emailtest',
            telephone:'0769',
            siteweb:'site',
            remarque:'Remarque'
        },
        fraisPort:20,
        articles:{
            'ET90':
            {
                '080-0EMAD013':{
                    '1000005926069':
                    {
                        reference_y2:'080-0EMAD013',
                        codebarre:'1000005926069',
                        code_couleur:'01',
                        couleur:'Noir',
                        codebarre:'3663779244609',
                        ean13_y2:'',code_theme:'ET90',
                        theme:'MADRAS',
                        marque:'etrier',
                        designation:'Porte-cartes',
                        vte_euro:59,
                        vte_negoce:25,
                        qte:0,
                        dateLivraison:'2025-10-15'
                    }
                }
            }
        },
        signature:{exist:false,link:'',file:''}

    })
    let codeMarque=ref('731')
    function nouvelleCommande(){
        authentification.value.type='create_order';
        getCommandeNegoce('tok_1_e4a2f8b1c3d5e6f7a8b9c0d1e2f3a4b5')
       
    }
    watch(
        () => filtre.value.rechercher,
        (newCode, oldCode) => {
            if (newCode) {
                let regex = new RegExp(filtre.value.rechercher, "i")
                negocesTableFiltred.value=negocesTable.value.filter(el=>(`${el.title.title}${el.fournisseur.codeAgent}${el.fournisseur.agent}${el.fournisseur.etablissement}`).match(regex))
            }
        },
        { immediate: true }
    )
    watch(
        () => negoce.value.client.dateLivraison,
        (newCode, oldCode) => {
            if (newCode) {
                for(let theme in negoce.value.articles){
                    for(let ref in negoce.value.articles[theme]){
                        for (let cab in negoce.value.articles[theme][ref]){
                            negoce.value.articles[theme][ref][cab].dateLivraison=newCode
                        }
                    }
                }
            }
        },
        { immediate: true }
    )
    watch(
        () => negoce.value.fournisseur.codeAgent,
        (newCode, oldCode) => {
            if (newCode) {
                const agent = commercialItems.value.find(item => item.code === newCode.code)
                if (agent && negoce.value.fournisseur.agent !== agent.libelle) {
                    negoce.value.fournisseur.agent=agent.libelle
                }
            } else {
                // Si le code est effacé, effacer aussi le nom
                negoce.value.fournisseur.agent = ''
            }
        },
        { immediate: true }
    )
    watch(
        () => negoce.value.fournisseur.agent,
        (newCode, oldCode) => {
            if (newCode) {
                
                // console.log(newCode);
                const agent = commercialItems.value.find(item => item.code === newCode.code)
                
                
                if (agent && negoce.value.fournisseur.codeAgent !== agent.code) {
                    negoce.value.fournisseur.codeAgent=agent.code
                }
            } else {
            // Si le code est effacé, effacer aussi le nom
                negoce.value.fournisseur.codeAgent = ''
            }
        },
        { immediate: true }
    )
    const formClient = ref(null)
    const clientValide = ref(false)

    // Date du jour en heure locale (toISOString donnerait la veille entre minuit et 1-2 h)
    const aujourdhui = () => new Date().toLocaleDateString('sv-SE') // "AAAA-MM-JJ"

    const regles = {
    obligatoire: v => (!!v && String(v).trim() !== '') || 'Champ obligatoire',
    email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) || 'Email invalide',
    telephone: v => !v || /^\+?[\d\s.\-()]{9,20}$/.test(v) || 'Téléphone invalide',
    tvaSiret: v => {
        if (!v) return true
        const s = String(v).replace(/\s/g, '').toUpperCase()
        return /^\d{14}$/.test(s)                 // SIRET : 14 chiffres
            || /^[A-Z]{2}[0-9A-Z]{8,12}$/.test(s) // TVA intracom : FR12345678901, BE0123456789…
            || 'SIRET (14 chiffres) ou n° TVA (ex. FR12345678901)'
    },
    pasDansLePasse: v => !v || v >= aujourdhui() || 'La date ne peut pas être passée',
    max: n => v => !v || String(v).length <= n || `${n} caractères maximum`,
    }
    let itemsClient=ref([])
    let newClient=ref(false)
    let oldClient=ref({})
    function addNewClient(type){
        if(type=='create'){
            oldClient.value={
                ...negoce.value.client,
                codeClient: negoce.value.fournisseur.codeClient,
                nomClient: negoce.value.fournisseur.nomClient
            }
            newClient.value=true
            // negoce.value.numero = null
            // negoce.value.file = null
            negoce.value.fournisseur = { ...negoce.value.fournisseur, codeClient: null, nomClient: null }
            negoce.value.client = clientVide(negoce.value.client.dateLivraison)
        }else{
            negoce.value.fournisseur.codeClient
            negoce.value.fournisseur.nomClient
            negoce.value.client = oldClient.value
            newClient.value=false

        }
    }
    
    // Watcher pour le code client
    watch(
        () => negoce.value.fournisseur.codeClient,
        (newCode, oldCode) => {
            if (newCode) {
            const client = itemsClient.value.find(item => item.t_tiers === newCode.t_tiers)
            // console.log(client);
            
            if (client && negoce.value.fournisseur.nomClient !== client.t_libelle) {
                negoce.value.fournisseur.codeClient=client.t_tiers
                negoce.value.fournisseur.nomClient = client.t_libelle
                negoce.value.client={...negoce.value.client,
                    enseigne:client.t_libelle,
                    raisonSociale:client.t_libelle,
                    tvaSiret:client.t_siret,
                    adresseLiv:{
                        adresse:`${client.t_adresse1} - ${client.t_codepostal} - ${client.t_ville} - ${client.t_pays}`,
                        libelleAdresse:client.t_libelle,
                        adresse1: client.t_adresse1,
                        adresse2: client.t_adresse2,
                        codePostal: client.t_codepostal,
                        ville: client.t_ville,
                        pays: client.t_pays
                    },
                    adresseFac:{
                        adresse:`${client.t_adresse1} - ${client.t_codepostal} - ${client.t_ville} - ${client.t_pays}`,
                        libelleAdresse:client.t_libelle,
                        adresse1: client.t_adresse1,
                        adresse2: client.t_adresse2,
                        codePostal: client.t_codepostal,
                        ville: client.t_ville,
                        pays: client.t_pays
                    },
                    contact:'',
                    email:client.t_email,
                    telephone:client.t_telephone,
                    siteweb:'',
                    remarque:''
                }
                // console.log(negoce.value.fournisseur);
            }
            } else {
            // Si le code est effacé, effacer aussi le nom
            negoce.value.fournisseur.nomClient = ''
            }
        },
        { immediate: true }
    )
    const saisonRules = [
        (value) => {
            if (!value) return 'La saison est requise'
            return true
        },
        (value) => {
            const regex = /^[HE]\d{2}$/
            if (!regex.test(value)) {
            return 'La saison doit commencer par H ou E suivi de 2 chiffres (ex: H25, E25)'
            }
            return true
        },
        (value) => {
            const year = parseInt(value.substring(1), 10)
            const currentYear = new Date().getFullYear() % 100
            if (year < 0 || year > 99) {
            return 'L\'année doit être comprise entre 00 et 99'
            }
            return true
        }
    ]
    // Watcher pour le nom client
    watch(
        () => negoce.value.fournisseur.nomClient,
        (newNom, oldNom) => {
            if (newNom) {
                const client = itemsClient.value.find(item => item.t_tiers === newNom.t_tiers)
                // console.log(client);
                if (client && negoce.value.fournisseur.codeClient !== client.t_tiers) {
                    negoce.value.fournisseur.codeClient = client.t_tiers
                    negoce.value.fournisseur.nomClient = client.t_libelle
                    negoce.value.client={...negoce.value.client,
                        enseigne:client.t_libelle,
                        raisonSociale:client.t_libelle,
                        tvaSiret:client.t_siret,
                        adresseLiv:{
                            adresse:`${client.t_adresse1} - ${client.t_codepostal} - ${client.t_ville} - ${client.t_pays}`,
                            libelleAdresse:client.t_libelle,
                            adresse1: client.t_adresse1,
                            adresse2: client.t_adresse2,
                            codePostal: client.t_codepostal,
                            ville: client.t_ville,
                            pays: client.t_pays
                        },
                        adresseFac:{
                            adresse:`${client.t_adresse1} - ${client.t_codepostal} - ${client.t_ville} - ${client.t_pays}`,
                            libelleAdresse:client.t_libelle,
                            adresse1: client.t_adresse1,
                            adresse2: client.t_adresse2,
                            codePostal: client.t_codepostal,
                            ville: client.t_ville,
                            pays: client.t_pays
                        },
                        contact:'',
                        email:client.t_email,
                        telephone:client.t_telephone,
                        siteweb:'',
                        remarque:''
                    }
                    // console.log(negoce.value.fournisseur);
                    
                }
            } else {
                // Si le nom est effacé, effacer aussi le code
                negoce.value.fournisseur.codeClient = ''
            }
        },
        { immediate: true }
    )
    const state = reactive({
        count: 0,
        option: {
            penColor: "rgb(0, 0, 0)",
            backgroundColor: "rgb(255,255,255)"
            },
            disabled: false
        })
    // Enregistrer les composants de Chart.js nécessaires
    // ChartJS.register(Title, Tooltip, Legend, ArcElement)
    ChartJS.register(
        Title,
        Tooltip,
        Legend,
        ArcElement,
        BarElement,
        CategoryScale,
        LinearScale
    )
    // Données du graphique
    
    const chartData = computed(() => ({
        labels: chartData1().tabTheme,
        datasets: [
            {
                label: 'Usage',
                backgroundColor: chartData1().colorTab,
                data: chartData1().tabQte,
            },
        ],
    }))
    const chartDataStats = computed(() => {
        const data = chartData2()
        // console.log(data.tabQte);
        
        return {
            labels: data.tabTheme,
            datasets: [{
            label: `Données ${axe.value.showPercent?'% ':''}`,
            data: data.tabQte,
            backgroundColor: data.colorTab
            }]
        }
    })
    
    
    ChartJS.register(
        Title,
        Tooltip,
        Legend,
        ArcElement,
        BarElement,
        CategoryScale,
        LinearScale
    )

    const pieOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'right' }
        }
    }

    const barOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: { beginAtZero: true }
        }
    }
    let statsTable=ref([])
    function chartData2() {
        const qte = { autre: 0 };
        const colorTab = [generateRandomColor()];
        let sum = 0;
        
        const data = getDataSource();
        // const { axe.value.x, axe.value.y, showPercent } = axe.value;
        // axe.value.x, axe.value.y, showPercent
        // console.log({ axe.value.x, axe.value.y, showPercent } );
        
        // Traitement unique
        Object.values(data).forEach(item => {
            if (!item || item[axe.value.x] === undefined) return;
            if(item[axe.value.x] ){
                const xVal = item[axe.value.x].toString();
                const yVal = Number(item[axe.value.y]) || 0;
                
                if (!xVal) {
                    qte.autre += yVal;
                } else {
                    if (!qte[xVal]) {
                        colorTab.push(generateRandomColor());
                        qte[xVal] = yVal;
                    } else {
                        qte[xVal] += yVal;
                    }
                }
                sum += yVal;
            }
            
        });
        
        // Nettoyage et retour
        if (qte.autre === 0) {
            delete qte.autre;
            colorTab.shift();
        }
        
        const tabTheme = Object.keys(qte);
        let tabQte = Object.values(qte);
        
        if (axe.value.showPercent) {
            const factor = 100 / sum;
            tabQte = tabQte.map(value => value * factor);
        }
        // console.log({ tabTheme, colorTab, tabQte });
        
        return { tabTheme, colorTab, tabQte };
        
        function getDataSource() {
            return grapheType.value === 'tiers' 
                ? tiersTable.value
                : axe.value.source === 'GLOBAL'
                    ? statsTable.value
                    : statsTableFiltred.value;
        }
        
        function generateRandomColor() {
            return '#' + ((Math.random() * 0xFFFFFF) << 0).toString(16).padStart(6, '0');
        }
    } 
    const getNonEmptyPhotoNames = (data) => {
        if (!data || typeof data !== 'object') return []
       
        return Object.values(data)
        .filter(item => item && item.photo_name && item.photo_name.trim() !== '')
        .map(item => item.photo_name.trim())[0]
    }
    // watch(
    //     codeMarque,
    //     (newValue, oldValue) => {
            
    //         console.log(codeMarque.value);
            
    //         commercialItems.value=commercialItems.value.filter(el=>el.code_marque==codeMarque.value)
    //         console.log('commercialItems',commercialItems.value);
    //         commercialItemsFiltred.value=commercialItems.value
    //     },
    //     { deep: true } // Important pour surveiller les changements dans l'objet
    // )
    
    watch(
        axe,
        (newValue, oldValue) => {
            chartData2()
        },
        { deep: true } // Important pour surveiller les changements dans l'objet
    )
    
    let readyToExport=ref(true)
    watch(
        filtreSingleParams,
        (newValue, oldValue) => {
            readyToExport.value=false
        },
        { deep: true } // Important pour surveiller les changements dans l'objet
    )
    // Options du graphique
    const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    
    } 
    const signature1 = ref(null)
    let authorized=computed(()=>{
        return {
           modif: store.state.user.groupe=='N'?true:false,
           signe: store.state.user.groupe=='N'&&negoce.value.signature.exist?true:false

        }
        // return  store.state.user.groupe=='N'?true:false
    })
    let fraisPort=computed(()=>{
        if(negoce.value.fournisseur.type?.code=='' || negoce.value.fournisseur.type?.code=='MEP'){
            if(Number(totaleHtCde2(negoce.value.articles).totale) * Number(1 - negoce.value.remise_pied/100)<1500){
                return 20 
            }else{
                return 0
            }
        }else if(negoce.value.fournisseur.type?.code=='REA' || negoce.value.fournisseur.type?.code=='REA'){
            if(Number(totaleHtCde2(negoce.value.articles).totale) * Number(1 - negoce.value.remise_pied/100)<500){
                return 20 
            }else{
                return 0
            }
        } else{
            return 20
        }
       
    })
    // Number(totaleHtCde2(negoce.articles).totale) * Number(1 - negoce.remise_pied/100) + Number(negoce.fraisPort)
    ref(false)
    let tab=ref()
    let dialogaAjout=ref(false)
    const panel = ref([2])
    const panelFilter= ref([])
    const panelModeles=ref([])
    const panelOutils=ref([])
    const panelCommandes=ref([])
    const readonly = ref(false)
    let rechercherArticle=ref()
    let rechercherArticleStatut=ref({statut:false,msg:''})
    function getArticle(ean13){
        if (ean13) {rechercherArticle.value=ean13} 
        for (let theme in store.state.articles[codeMarque.value]){
            for(let ref in store.state.articles[codeMarque.value][theme]){
                if(ref==rechercherArticle.value){
                    selectArticle(theme,ref)
                    rechercherArticle.value=''
                    rechercherArticleStatut.value={statut:false}
                    return
                }
                for(let cab in store.state.articles[codeMarque.value][theme][ref]){
                    if(cab==rechercherArticle.value || rechercherArticle.value==store.state.articles[codeMarque.value][theme][ref][cab].ean13_y2){                    
                        articleToAdd.value={[cab]:
                            {
                            ...store.state.articles[codeMarque.value][theme][ref][cab],qte:1,remise:0,dateLivraison:negoce.value.client.dateLivraison
                            }
                        }
                        addArticle()
                        dialogaAjout.value=false
                        rechercherArticle.value=''
                        rechercherArticleStatut.value={statut:false}
                        return
                    }
                }
            }
        }
        rechercherArticleStatut.value={statut:true,msg:"L'article n'existe pas!"}
    }
  
    let articleToAdd=ref()
    // function ajoutClient(){
    //     negoce.value.fournisseur.codeClient=negoce.value.fournisseur.codeClient.split('-')[0].trim()
    //     let clientSelected=tiersTable.find(cl=>cl.t_tiers==negoce.value.fournisseur.codeClient)
    //     // negoce.value.client={
    //     // negoce.value.client.enseigne:'enseigne',
    //     negoce.value.client.raisonSociale=clientSelected.t_prenom
    //     negoce.value.client.tvaSiret=clientSelected.t_siret
    //     negoce.value.client.adresseLiv={
    //         adresse:'30 rue national - 59270 - Bailleul - France' `${clientSelected.t_adress1} - ${clientSelected.t_codepostal} - `,
    //         libelleAdresse:'test',
    //         adresse1: '30 rue national',
    //         adresse2: 'test',
    //         codePostal: '59270',
    //         ville: 'Bailleul',
    //         pays: 'France'
    //     }
    //     negoce.value.client.adresseFac={
    //         adresse:'30 rue national - 59270 - Bailleul - France',
    //         libelleAdresse:'adresse Fact',
    //         adresse1: '30 rue national',
    //         adresse2: 'test',
    //         codePostal: '59270',
    //         ville: 'Bailleul',
    //         pays: 'France'
    //     },
    //     negoce.value.client.contact='contact_test'
    //     negoce.value.client.email='emailtest'
    //     negoce.value.client.telephone='0769'
    //     negoce.value.client.siteweb='site'
    //     negoce.value.client.remarque='Remarque'
    // }
    // watch(
    //     () => negoce.value.fournisseur.codeClient,
    //     (newStatut, oldStatut) => {
    //         negoce.value.fournisseur.codeClient=negoce.value.fournisseur.codeClient.split('-')[0].trim()
    //         let clientSelected=tiersTable.find(cl=>cl.t_tiers==negoce.value.fournisseur.codeClient.split('-')[0].trim())
    //         negoce.value.client={
    //         enseigne:'enseigne',
    //         raisonSociale:'test',
    //         tvaSiret:'TVA_TEST',
    //         dateLivraison:'2025-10-15',
    //         adresseLiv:{
    //             adresse:'30 rue national - 59270 - Bailleul - France',
    //             libelleAdresse:'test',
    //             adresse1: '30 rue national',
    //             adresse2: 'test',
    //             codePostal: '59270',
    //             ville: 'Bailleul',
    //             pays: 'France'
    //         },
    //         adresseFac:{
    //             adresse:'30 rue national - 59270 - Bailleul - France',
    //             libelleAdresse:'adresse Fact',
    //             adresse1: '30 rue national',
    //             adresse2: 'test',
    //             codePostal: '59270',
    //             ville: 'Bailleul',
    //             pays: 'France'
    //         },
    //         contact:'contact_test',
    //         email:'emailtest',
    //         telephone:'0769',
    //         siteweb:'site',
    //         remarque:'Remarque'
    //        }
    //     },
    //     { deep: false } // deep: false car on ne watch qu'une propriété primitive
    // );
    const popupVisible = ref(false)
    let photosFripe=ref({
    photos:[],
    firstPhoto:'',
    PhotosCount:0
    })
    const photo_name = ref('')
    const ouvrirPopUpPhotos = async (item) => {

        
        photo_name.value=getCurrentPhotoName(item)
        if(photo_name.value.photo!=''){
            let photosTab=[...new Set(
                Object.values(store.state.articles[item.code_marque][item.code_theme][item.reference_y2])
                    .map(ref => ref={couleur : `${ref.code_couleur} - ${ref.couleur}`,photo:ref.photo_name})
                    .filter(code => code && code.photo.trim() !== '')
            )];
            srcImage.value=`https://www.edisac.com/images/article_la/${photo_name.value.photo}` 
            photosFripe.value={
            photos:photosTab,
            firstPhoto:{couleur : photo_name.value.couleur,photo:photo_name.value.photo},
            srcImage:srcImage.value,
            PhotosCount:photosTab.length,
            index: photosTab.findIndex(el => el.photo === photo_name.value.photo)
            }

            popupVisible.value=true
        }
    }
    let articlePhoto=ref()
    const getCurrentPhotoName = (item) => {
    articlePhoto.value=store.state.articles[item.code_marque][item.code_theme][item.reference_y2][item.codebarre]
    if (!articlePhoto.value) return ''
    photo_name.value=articlePhoto.value.photo_name
    return {couleur:`${articlePhoto.value.code_couleur} - ${articlePhoto.value.couleur}`,photo:articlePhoto.value.photo_name}
    }
    function addArticle(){
      for(let art in articleToAdd.value){
        if(articleToAdd.value[art].qte){
            if(!negoce.value.articles[articleToAdd.value[art].code_theme]){
                negoce.value.articles={
                    ...negoce.value.articles,
                    [articleToAdd.value[art].code_theme]: negoce.value.articles[articleToAdd.value[art].code_theme]=
                    {...negoce.value.articles[articleToAdd.value[art].code_theme],
                        [articleToAdd.value[art].reference_y2]:{
                            [articleToAdd.value[art].codebarre]:articleToAdd.value[art]
                        }
                    }
                }
                
            }
            else if(!negoce.value.articles[articleToAdd.value[art].code_theme][articleToAdd.value[art].reference_y2]){               
                negoce.value.articles[articleToAdd.value[art].code_theme]=
                {...negoce.value.articles[articleToAdd.value[art].code_theme],
                    [articleToAdd.value[art].reference_y2]:{
                        [articleToAdd.value[art].codebarre]:articleToAdd.value[art]
                    }
                }
            }else if(!negoce.value.articles[articleToAdd.value[art].code_theme][articleToAdd.value[art].reference_y2][articleToAdd.value[art].codebarre]){             
                negoce.value.articles[articleToAdd.value[art].code_theme][articleToAdd.value[art].reference_y2]=
                {...negoce.value.articles[articleToAdd.value[art].code_theme][articleToAdd.value[art].reference_y2],
                    [articleToAdd.value[art].codebarre]:articleToAdd.value[art]
                }
            }
        }
      }
    }
    let articleToAddTab=ref([])
    function etatStock(article){
        if(article.stock){
            if(article.stock.NEGO&&article.stock.NEGO>=30){
                return {icon:"$success",color:"success"}
            }else if(article.stock.NEGO&&article.stock.NEGO>=10){
                return {icon:"$info",color:"primary"}
            }else if(article.stock.NEGO&&article.stock.NEGO>=3){
                return {icon:"$info",color:"warning"}
            }else{
                return {icon:"$error",color:"error"}
            }
            
        }else{
            return {icon:"mdi-delete-forever",color:"error"}
        }
        
    }
    function gererateEAN13(cab){

        let ean=Number(cab)
        let ean13=ean.toString().substring(0,12)
        let c=Number(ean13[0])+Number(ean13[2])+Number(ean13[4])+Number(ean13[6])+Number(ean13[8])+Number(ean13[10])
        let b= 3*(Number(ean13[1])+Number(ean13[3])+Number(ean13[5])+Number(ean13[7])+Number(ean13[9])+Number(ean13[11]))
        let cle=(10-(b+c)%10)%10
        return ean13+cle.toString()!=cab&&cab!=''?{erreur:true,color:'red'}: {erreur:false}
    }
      let rules=(value)=>{
        if (value){
            return [true]
        } else{
            return [`Le ean13 n'est pas en bon format`]
        }
        
    }
    function selectArticle(theme,codeArticle){
        rechercher.value=''
        rechercherArticleStatut=ref({statut:false,msg:''})
        if(codeArticle){
            articleToAddTab.value=[]

            tab.value="one"
            for(let art in store.state.articles[codeMarque.value][theme][codeArticle]){
                if(!negoce.value.articles[theme]){
                    store.state.articles[codeMarque.value][theme][codeArticle][art]={
                        ...store.state.articles[codeMarque.value][theme][codeArticle][art],qte:0,remise:0,dateLivraison:negoce.value.client.dateLivraison
                        }
                        articleToAddTab.value.push(store.state.articles[codeMarque.value][theme][codeArticle][art])
                }else{
                    if(!negoce.value.articles[theme][codeArticle]){
                    store.state.articles[codeMarque.value][theme][codeArticle][art]={
                        ...store.state.articles[codeMarque.value][theme][codeArticle][art],qte:0,remise:0,dateLivraison:negoce.value.client.dateLivraison
                        }
                        articleToAddTab.value.push(store.state.articles[codeMarque.value][theme][codeArticle][art])
                    }else{
                        if(!negoce.value.articles[theme][codeArticle][art]){
                            store.state.articles[codeMarque.value][theme][codeArticle][art]={
                            ...store.state.articles[codeMarque.value][theme][codeArticle][art],qte:0,remise:0,dateLivraison:negoce.value.client.dateLivraison
                            }
                            articleToAddTab.value.push(store.state.articles[codeMarque.value][theme][codeArticle][art])
                        }  
                    }
                }
                
                
            }
            articleToAdd.value= store.state.articles[codeMarque.value][theme][codeArticle]
            articleToAddTabFilter.value=articleToAddTab.value
          
        }else{
            if(theme){
                articleToAddTab.value=[]
                tab.value="two"
                articleToAdd.value= store.state.articles[codeMarque.value][theme]
                for(let ref in store.state.articles[codeMarque.value][theme]  ){
                    if(!negoce.value.articles[theme]){
                        articleToAddTab.value.push({code:ref,libelle:store.state.articles[codeMarque.value][theme][ref][Object.keys(store.state.articles[codeMarque.value][theme][ref])[0]].designation,theme:store.state.articles[codeMarque.value][theme][ref][Object.keys(store.state.articles[codeMarque.value][theme][ref])[0]].code_theme})
                    }else{
                        if(!negoce.value.articles[theme][ref]){
                          articleToAddTab.value.push({code:ref,libelle:store.state.articles[codeMarque.value][theme][ref][Object.keys(store.state.articles[codeMarque.value][theme][ref])[0]].designation,theme:store.state.articles[codeMarque.value][theme][ref][Object.keys(store.state.articles[codeMarque.value][theme][ref])[0]].code_theme})  
                        }
                    }
                }
                articleToAddTabFilter.value=articleToAddTab.value
            }
            else{   
                // console.log(articleToAddTabFilter.value);             
                articleToAddTab.value=[]
                tab.value="three"
                articleToAdd.value= store.state.articles[codeMarque.value]
                for(let th in store.state.articles[codeMarque.value] ){
                    if(!negoce.value.articles[th]){
                        articleToAddTab.value.push({code:th,libelle:store.state.articles[codeMarque.value][th][Object.keys(store.state.articles[codeMarque.value][th])[0]][Object.keys(store.state.articles[codeMarque.value][th][Object.keys(store.state.articles[codeMarque.value][th])[0]])[0]].theme})
                    }
                }
                articleToAddTabFilter.value=articleToAddTab.value
            }
            
        }
    }
        let grapheType=ref()
    let articleToDelete=ref()
    function supprimer(){
        if(articleToDelete.value.type=='color'){
            if(Object.keys(negoce.value.articles[articleToDelete.value.art.code_theme][articleToDelete.value.art.reference_y2]).length>1){
            delete negoce.value.articles[articleToDelete.value.art.code_theme][articleToDelete.value.art.reference_y2][articleToDelete.value.art.codebarre];
        }else{
            if(Object.keys(negoce.value.articles[articleToDelete.value.art.code_theme]).length>1){
                delete negoce.value.articles[articleToDelete.value.art.code_theme][articleToDelete.value.art.reference_y2];
            }else{ 
                if(Object.keys(negoce.value.articles).length>1){
                    delete negoce.value.articles[articleToDelete.value.art.code_theme]
                }
            }
        }
        }else{
            if(Object.keys(negoce.value.articles[articleToDelete.value.art.code_theme]).length>1){
                delete negoce.value.articles[articleToDelete.value.art.code_theme][articleToDelete.value.art.reference_y2];
            }else{ 
                if(Object.keys(negoce.value.articles).length>1){
                    delete negoce.value.articles[articleToDelete.value.art.code_theme]
                }
            }
        }
        // console.log(negoce.value.articles);
        
    }
    let  getElevationClass = computed(() => {
      if (authentification.value.type == 'edit_model' || authentification.value.type == 'edit_order') {
        return 'elevation-red'
      } else if (authentification.value.type == 'add_model') {
        return 'elevation-green'
      } else {
        return 'elevation-grey'
      }
    })
    function totaleQte(params) {
        let qte=0
        for (let el in params){
            qte+=Number(params[el].qte)
        }
        return qte
    }
    function totaleHt(params) {
        let totale=0
        for (let el in params){
            totale+=Number(params[el].qte)*params[el].vte_negoce*(1-params[el].remise/100)
        }
        return totale.toFixed(2)
    }
    function totaleQteCde(params) {
        let qte=0
        for(let el in params){
            for (let el1 in params[el]){
                qte+=Number(params[el][el1].qte)
            }
        }
        return qte
    }
    function totaleHtCde(params) {
        let totale=0
        for(let el in params){
            for (let el1 in params[el]){
                totale+=Number(params[el][el1].qte)*params[el][el1].vte_negoce*(1-params[el][el1].remise/100)
            }
        }
        return  Math.round(totale * 100) / 100 
    }
    function totaleHtCde2(params) {
        let totale=0
        let qte=0
        for(let el in params){
            for (let el1 in params[el]){
                for(let el2 in params[el][el1]){
                    totale+=Number(params[el][el1][el2].qte)*params[el][el1][el2].vte_negoce*(1-params[el][el1][el2].remise/100)
                    qte+=params[el][el1][el2].qte
                }
                
            }
        }
        return {
            totale: Math.round(totale * 100) / 100,
            qte:qte
        }
    }
    function chartData1() {
        const colorPalette = [
            "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF",
            "#FF9F40", "#E7E9ED", "#FF6B6B", "#6BCB77", "#FFD93D",
            "#845EC2", "#D65DB1", "#FF6F91", "#FF9671", "#FFC75F",
            "#F9F871", "#2C73D2", "#0081CF", "#0089BA", "#008E9B",
            "#008F7A", "#B39CD0", "#FFAAA5", "#FCF6BD", "#D0F4DE",
            "#A9DEF9", "#E4C1F9", "#FFCAD4", "#B5EAD7", "#C7CEEA"
        ];  
        let tab=[]
        let colorTab=[]
        let tabQte=[]
        let i=0
        let qte=0
        let params=negoce.value.articles
        for(let el in params){
            tab.push(params[el][Object.keys(params[el])[0]][Object.keys(params[el][Object.keys(params[el])[0]])[0]].theme)
            
            colorTab.push(colorPalette[i])
            i++
            for (let el1 in params[el]){
                for(let el2 in params[el][el1]){
                    qte+=params[el][el1][el2].qte
                } 
            }
            tabQte.push(qte),
            qte=0
        }
        return {tabTheme:tab,colorTab:colorTab,tabQte:tabQte}
    }
    const save = (t) => {
        negoce.value.signature.exist=true
        negoce.value.signature.link=signature1.value.save(t)   
        sendImages()   
        
    }
    
    const clear = () => {
        signature1.value.clear()
    }
    
    const undo = () => {
        signature1.value.undo();
    }
    const handleDisabled = () => {
        state.disabled = !state.disabled
    }
    const isEmpty = () => {
        signature1.value.isEmpty()
    }
    let rechercher=ref()
    let articleToAddTabFilter=ref()
    watch(rechercher,()=>{
        let regex = new RegExp(rechercher.value, "i")
        if(tab.value=='one'){
            articleToAddTabFilter.value=articleToAddTab.value.filter(el=>(`${el.code_couleur}${el.couleur}${el.codebarre}${el.ean13_y2}`).match(regex))
        }else{
            articleToAddTabFilter.value=articleToAddTab.value.filter(el=>(`${el.code}${el.libelle}`).match(regex))
        } 
    })
    const exportToExcel = (excelData) => {
    // Définir les champs à exporter avec leurs en-têtes en français
        const fieldsToExport = [
            { key: 'gl_naturepieceg', header: 'Nature Document' },
            { key: 'date_livraison', header: 'Date Livraison' },
            { key: 'numero', header: 'Numéro' },
            { key: 'gp_librepiece3', header: 'Saison' },
            { key: 'etablissement', header: 'Établissement' },
            { key: 'marque', header: 'Marque' },
            { key: 'rayon', header: 'Rayon' },
            { key: 'ga_familleniv3', header: 'Code-Sous-Famille' },
            { key: 'sousfamille', header: 'Sous-Famille' },
            { key: 'theme', header: 'Thème' },
            { key: 'ga_codearticle', header: 'Code Article' },
            { key: 'codefourn', header: 'Réf Fournisseur' },
            { key: 'couleur', header: 'Couleur' },
            { key: 'taille', header: 'Taille' },
            { key: 'codebarre', header: 'Code-barres' },
            { key: 'cab_secondaire', header: 'CAB Secondaire' },
            { key: 'gl_qtestock', header: 'Quantité' },    
            { key: 'gl_puhtnet', header: 'PU HT Net' },
            { key: 'gl_totalht', header: 'TOTAL HT Net' }
        ];

        // Filtrer et formater les données
        const filteredData = excelData.map(item => {
            const row = {};
            fieldsToExport.forEach(field => {
                const value = item[field.key];
                
                // Formater les dates si nécessaire
                if (field.key === 'date_livraison' && value) {
                    // Convertir la date en format lisible
                    const date = new Date(value);
                    if (!isNaN(date.getTime())) {
                        row[field.header] = date.toLocaleDateString('fr-FR');
                    } else {
                        row[field.header] = value;
                    }
                } else if (field.key === 'gl_qtestock' || field.key === 'gl_puhtnet' || field.key ===  'gl_totalht') {
                    // Formater les nombres
                    const numValue = parseFloat(value);
                    row[field.header] = isNaN(numValue) ? 0 : numValue;
                } else {
                    // Valeur textuelle
                    row[field.header] = value !== undefined && value !== null ? value : '';
                }
            });
            return row;
        });

        // Créer la feuille Excel
        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        
        // Appliquer les styles aux en-têtes
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        const headerStyle = {
            font: { bold: true, color: { rgb: "FFFFFF" } },
            fill: { fgColor: { rgb: "2E75B6" } }, // Bleu
            alignment: { horizontal: "center", vertical: "center" },
            border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } }
            }
        };

        // Appliquer le style aux en-têtes (première ligne)
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
            if (worksheet[cellAddress]) {
                worksheet[cellAddress].s = headerStyle;
            }
        }

        // Ajuster la largeur des colonnes automatiquement
        const colWidths = [];
        for (let C = range.s.c; C <= range.e.c; ++C) {
            let maxLength = 0;
            
            // Vérifier la longueur de l'en-tête
            const headerCell = XLSX.utils.encode_cell({ r: 0, c: C });
            if (worksheet[headerCell] && worksheet[headerCell].v) {
                maxLength = Math.max(maxLength, worksheet[headerCell].v.toString().length);
            }
            
            // Vérifier la longueur des données
            for (let R = 1; R <= range.e.r; ++R) {
                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
                if (worksheet[cellAddress] && worksheet[cellAddress].v) {
                    maxLength = Math.max(maxLength, worksheet[cellAddress].v.toString().length);
                }
            }
            
            // Ajouter un peu de marge
            colWidths.push({ wch: Math.min(Math.max(maxLength + 2, 10), 50) });
        }
        worksheet['!cols'] = colWidths;

        // Ajouter un filtre automatique
        worksheet['!autofilter'] = { ref: XLSX.utils.encode_range(range) };

        // Créer le classeur
        const workbook = XLSX.utils.book_new();
        const sheetName = `Export_Negoces_${getCurrentDateYYYYMMDD()}`;
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.substring(0, 31)); // Limite à 31 caractères

        // Exporter le fichier
        const fileName = `negoces_export_${getCurrentDateYYYYMMDD()}.xlsx`;
        XLSX.writeFile(workbook, fileName);
        
        // console.log(`✅ Fichier exporté : ${fileName} avec ${filteredData.length} lignes`);
    };

    // Version simplifiée sans styles avancés
    const exportToExcelSimple = (excelData) => {
        const fieldsToExport = [
            'gl_naturepieceg',
            'date_livraison',
            'numero',
            'gp_librepiece3',
            'etablissement',
            'marque',
            'rayon',
            'ga_familleniv3',
            'sousfamille',
            'theme',
            'ga_codearticle',
            'codefourn',
            'couleur',
            'taille',
            'codebarre',
            'cab_secondaire',
            'gl_qtestock',
            'gl_pmrp'
        ];

        // Filtrer les données
        const filteredData = excelData.map(item => {
            const row = {};
            fieldsToExport.forEach(field => {
                row[field] = item[field] !== undefined ? item[field] : '';
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Export');
        XLSX.writeFile(workbook, `negoces_${getCurrentDateYYYYMMDD()}.xlsx`);
    };

// Fonction pour obtenir la date au format YYYYMMDD
// function getCurrentDateYYYYMMDD() {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, '0');
//     const day = String(now.getDate()).padStart(2, '0');
//     return `${year}${month}${day}`;
// }
    function getCurrentDateYYYYMMDD() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois commence à 0
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}${month}${day}`;
    }
    async function getArticles(marque){
        store.commit('updateWaiting')
        let params=
        {   
            marques:`{${marque}}`
        }
        let url=    `https://my.edisac.com/goapi/articlesdeep`
        let config = {
        method: 'get',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
        },
        url: url,
        params:params
        };
        return axios.request(config)
        .then((response) => {
            store.commit('addArticles',response.data.articles) 
            // console.log(response.data.articles);
            
            store.commit('updateWaiting')    
        })
        .catch((error) => {
        //console.log(error);
        });
        
    }
    async function createNewClient(){
        const { valid } = await formClient.value.validate()
        if (!valid) return
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://my.edisac.com/api/clientnegoce',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
        },
        data : {...negoce.value.client,
            
            t_libelle:negoce.value.client.raisonSociale,
            t_siret:negoce.value.client.tvaSiret,
            t_adresse1:negoce.value.client.adresseLiv.adresse1,
            t_codepostal:negoce.value.client.adresseLiv.codePostal,
            t_ville:negoce.value.client.adresseLiv.ville,
            t_pays:negoce.value.client.adresseLiv.pays?.libelle,
            t_email:negoce.value.client.email,
            t_telephone:negoce.value.client.telephone
        }
        }
        return axios.request(config)
        .then((response) => { 
            // console.log('response',response);
            // negoce.value.fournisseur.nomClient=negoce.value.fournisseur.raisonSociale
            itemsClient.value.push({
                t_tiers:response.data.tiers,
                t_libelle:negoce.value.client.raisonSociale,
                t_siret:negoce.value.client.tvaSiret,
                t_adresse1:negoce.value.client.adresseLiv.adresse1,
                t_codepostal:negoce.value.client.adresseLiv.codePostal,
                t_ville:negoce.value.client.adresseLiv.ville,
                t_pays:negoce.value.client.adresseLiv.pays?.libelle,
                t_email:negoce.value.client.email,
                t_telephone:negoce.value.client.telephone
            })
            negoce.value.fournisseur.codeClient=response.data.tiers
        // newClient.value=false  
        })
        .catch((error) => {
        //console.log(error);
        });
        
    }
    
    async  function sendImages(){
       if(negoce.value.signature.exist){
            let data = {
                reception:Math.round(new Date().getTime() / 1000),
                signature:negoce.value.signature.link,
                }
            let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://my.edisac.com/api/upload',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
            },
            data : data
            }
            return axios.request(config)
            .then((response) => { 
                
                negoce.value.signature.file=response.data.signature   
                sendCommandeNegoce()     
            })
            .catch((error) => {
            //console.log(error);
            });
       }
        
    }
    let numneg=ref()
    
    function getCmdNeg(item){
        negoce.value=item
        if(codeMarque.value!=negoce.value.fournisseur.code_marque){
            codeMarque.value=negoce.value.fournisseur.code_marque
            getArticles(Array.of(negoce.value.fournisseur.code_marque))
        }
        // codeMarque.value=negoce.value.fournisseur.code_marque
        
        
    }
    const extractNumber = (str) => {
        if (!str) return 0
        // Extrait tous les chiffres de la chaîne
        const matches = str.match(/\d+/)
        return matches ? parseInt(matches[0], 10) : 0
    }
    const findMaxNumero = (items) => {
    if (!items || items.length === 0) return null
    
    let maxItem = items[0]
    let maxNumber = extractNumber(items[0].numero)
    
    for (let i = 1; i < items.length; i++) {
        const currentNumber = extractNumber(items[i].numero)
        if (currentNumber > maxNumber) {
        maxNumber = currentNumber
        maxItem = items[i]
        }
    }

    return extractNumber(maxItem.numero)
    }
    let newModele=ref({
        marque:null,
        saison:null,
        dialog:false,
        remarque:null
    })
    let itemsModele=ref([
        // {numero:'E1',tiers:'test',token:'test',marque:['731'],title:'Etrier SS27',etablissement:'NEGO'},
        // {numero:'W1',tiers:'test',token:'test',marque:['742'],title:'Woomen SS27',etablissement:'NEGO'},
        // {numero:'C1',tiers:'test',token:'test',marque:['737'],title:'Caméléon SS27',etablissement:'NGEXT'}
    ])
    async function setNewModeleNegoce(){
        if(newModele.value.marque || newModele.value.saison){
            NegoceModeles()
            // let numero=''
            // getCommandeNegoce ('tok_1_e4a2f8b1c3d5e6f7a8b9c0d1e2f3a4b5')

            // if(newModele.value.marque.code=='737'){
            //     negoce.value.title.saison='RC20'+newModele.value.saison.split('H')[1]+(newModele.value.remarque?newModele.value.remarque:'')
            //     negoce.value.title.logo='cameleon_negoce.png'
            //     negoce.value.fournisseur.etablissement='NGEXT'
            //     numero=`C${findMaxNumero(itemsModele.value.filter(el=>el.numero.match(/C/)))+1}`
            //     NegoceModeles('add',{numero:numero,tiers:'test',token:'test',marque:['737'],title:'Caméléon '+negoce.value.title.saison,etablissement:'NGEXT'})
            //     negoce.value.numero=numero
            //     negoce.value.file=`ok_negoce_${numero}_1759602695.json`
            //     sendCommandeNegoce()
            // }else if(newModele.value.marque.code=='742'){
            //     negoce.value.title.saison=newModele.value.saison.match(/H/,'gmi')?('FW20'+newModele.value.saison.split('H')[1]+(newModele.value.remarque?newModele.value.remarque:'')):('SS20'+newModele.value.saison.split('E')[1]+(newModele.value.remarque?newModele.value.remarque:''))
            //     negoce.value.title.logo='woomen_negoce.png'
            //     negoce.value.fournisseur.etablissement='NEGO'
            //     numero=`W${findMaxNumero(itemsModele.value.filter(el=>el.numero.match(/W/)))+1}`
            //     NegoceModeles('add',{numero:numero,tiers:'test',token:'test',marque:['742'],title:'Woomen '+negoce.value.title.saison,etablissement:'NEGO'})
            //     negoce.value.numero=numero
            //     negoce.value.file=`ok_negoce_${numero}_1759602695.json`
            //     sendCommandeNegoce()
            // }else if(newModele.value.marque.code=='731'){
            //     negoce.value.title.saison=newModele.value.saison.match(/H/,'gmi')?('FW20'+newModele.value.saison.split('H')[1]+(newModele.value.remarque?newModele.value.remarque:'')):('SS20'+newModele.value.saison.split('E')[1]+(newModele.value.remarque?newModele.value.remarque:''))
            //     negoce.value.title.logo='etrier_negoce.png'
            //     negoce.value.fournisseur.etablissement='NEGO'
            //     numero=`E${findMaxNumero(itemsModele.value.filter(el=>el.numero.match(/E/)))+1}`
            //     NegoceModeles('add',{numero:numero,tiers:'test',token:'test',marque:['731'],title:'Etrier '+negoce.value.title.saison,etablissement:'NEGO'})
            //     negoce.value.numero=numero
            //     negoce.value.file=`ok_negoce_${numero}_1759602695.json`
            //     sendCommandeNegoce()
            // }
            newModele.value.dialog=false
        }else{
            newModele.value.dialog=true
        }
    }
    const clientVide = (dateLivraison) => {
    const adresse = () => ({ adresse: null, libelleAdresse: null, adresse1: null, adresse2: null,
                            codePostal: null, ville: null, pays: null })
    return { enseigne: null, raisonSociale: null, tvaSiret: null,dateLivraison:dateLivraison,
            adresseLiv: adresse(), adresseFac: adresse(),
            contact: null, email: null, telephone: null, siteweb: null, remarque: null }
    }

    async function getCommandeNegoce(token) {
        store.commit('updateWaiting')
        // console.log('store.state.user',store.state.user);
        // https://my.edisac.com/api/commandes/by-token
        try {
            const { data } = await axios.get('https://my.edisac.com/api/commandes/by-token', {
                params: { token },
                headers: { 
                    'Content-Type': 'application/json'
                    // ,'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
                },
            })
            // console.log(data);
            if (data.statut!='ok') {
                commandeNotExist.value = { exist: true,  new: 'rien' }
                router.replace({ path: '/login' })
                return
            }
            
            
            negoce.value = data.negocefile
            // console.log(negoce.value)
            commandeNotExist.value = { exist: true, numero: negoce.value.numero, new: 'old' }

            // Création ou duplication : le bon sert de modèle, on retire ce qui est propre au client
            if (/create|duplicate/.test(authentification.value?.type || '')) {
            negoce.value.numero = null
            negoce.value.file = null
            negoce.value.fournisseur.date=new Date().toISOString().split('T')[0]
            // negoce.value.client.dateLivraison=null
            negoce.value.fournisseur = { ...negoce.value.fournisseur, codeClient: null, nomClient: null }
            negoce.value.client = clientVide(negoce.value.client.dateLivraison)
            }
        } catch (error) {
            console.error('Erreur chargement négoce :', error)
        } finally {
            store.commit('updateWaiting') // toujours exécuté, même en cas d'erreur
        }
    }

    // async function getCommandeNegoce (numnegtoget,id,token){
    //     store.commit('updateWaiting')
    //     let url=    `https://my.edisac.com/api/negoce`
    //     let config = {
    //         method: 'get',
    //         url: url,
    //         params:{
    //             id:id,
    //             numero:numnegtoget,
    //             token:token
    //         }
    //     };
    //     return   axios.request(config)
    //     .then((response) => {
    //         store.commit('updateWaiting')
    //         if(response.data.exist){
    //             negoce.value=response.data
    //             commandeNotExist.value={exist:true,numero:numnegtoget,new:'old'}
                
                
    //             if(authentification.value.type.match(/create/)){
    //                 negoce.value.numero=NULL
    //                 negoce.value.file=NULL
    //                 negoce.value.fournisseur.codeClient = NULL
    //                 negoce.value.fournisseur.nomClient = NULL
    //                 negoce.value.client={
    //                     enseigne:NULL,
    //                     raisonSociale:NULL,
    //                     tvaSiret:NULL,
    //                     adresseLiv:{
    //                         adresse:NULL,
    //                         libelleAdresse:NULL,
    //                         adresse1: NULL,
    //                         adresse2: NULL,
    //                         codePostal: NULL,
    //                         ville: NULL,
    //                         pays: NULL
    //                     },
    //                     adresseFac:{
    //                         adresse:NULL,
    //                         libelleAdresse:NULL,
    //                         adresse1: NULL,
    //                         adresse2: NULL,
    //                         codePostal: NULL,
    //                         ville: NULL,
    //                         pays: NULL
    //                     },
    //                     contact:NULL,
    //                     email:NULL,
    //                     telephone:NULL,
    //                     siteweb:NULL,
    //                     remarque:NULL
    //                 }
    //             } else if(authentification.value.type.match(/duplicate/)){
    //                 console.log(authentification.value)
    //                 negoce.value.numero=NULL
    //                 negoce.value.file=NULL
    //                 negoce.value.fournisseur.codeClient = NULL
    //                 negoce.value.fournisseur.nomClient = NULL
    //                 negoce.value.client= {
    //                     enseigne:NULL,
    //                     raisonSociale:NULL,
    //                     tvaSiret:NULL,
    //                     adresseLiv:{
    //                         adresse:NULL,
    //                         libelleAdresse:NULL,
    //                         adresse1: NULL,
    //                         adresse2: NULL,
    //                         codePostal: NULL,
    //                         ville: NULL,
    //                         pays: NULL
    //                     },
    //                     adresseFac:{
    //                         adresse:NULL,
    //                         libelleAdresse:NULL,
    //                         adresse1: NULL,
    //                         adresse2: NULL,
    //                         codePostal: NULL,
    //                         ville: NULL,
    //                         pays: NULL
    //                     },
    //                     contact:NULL,
    //                     email:NULL,
    //                     telephone:NULL,
    //                     siteweb:NULL,
    //                     remarque:NULL
    //                 } 
    //             }
    //         }else{
    //             router.replace({ path: '/login' }) 
    //             commandeNotExist.value={exist:true,numero:numnegtoget,new:'rien'}
    //         }
            
    //     })
    //     .catch((error) => {
    //     //console.log(error);
    //     });
    // }
    async function getModeleCommande(item){
        codeMarque.value=item.code_marque;
        await getCommandeNegoce(item.token);
        await filtreCommandes(item);
        await getArticles(Array.of(item.code_marque))
    } 
    async function duplicateCommandeNegoce(item) {
        authentification.value.type='duplicate_order'
        getCommandeNegoce(item.token)
    }
    let negocesCommandes=ref([
        {saison:'H27',tiers:'TEST',numero:1,code_marque:'731'}
    ])
    let negocesCommandesFiltred=ref([])
    async function getCommandesNegoces (){
        // let url=    `https://my.edisac.com/api/getnegocecommandes`
        let url=    `https://my.edisac.com/api/commandes`
        let config = {
            method: 'get',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
            },
            params :{
                nature:'CC'
            },
            url: url
        };
        return   axios.request(config)
        .then((response) => {
            if(response){
                if(response.data.commandes){
                    negocesCommandes.value = response.data.commandes.map(el => {
                        return {
                            ...el,
                            numero: el.refinterne.split('_')[1],
                            tiers: el.tiers
                        };
                    });
                    negocesCommandesFiltred.value=negocesCommandes.value
                }
                
            }else{
                router.replace({ path: '/login' })
            }

        })
        .catch((error) => {
            if (error.response && error.response.status === 401) {
                // Token absent → rediriger vers login
                router.replace({ path: '/login' })
                // console.log('Non authentifié')
            } else if (error.response && error.response.status === 403) {
                // Token invalide/expiré → rediriger vers login
                router.replace({ path: '/login' })
                // console.log('Token invalide ou expiré')
            }

        });
    }
    async function filtreCommandes(){
        negocesCommandesFiltred.value=negocesCommandes.value.filter(el=>el.code_marque==model.value.item.code_marque && el.saison==model.value.item.saison)
        switch (model.value.item.code_marque) {
            case '731': 
                commercialItemsFiltred.value=supprimerDoublons(commercialItems.value.filter(el=>el.code&&el.code.match(/ETR/,'gmi')))
                
            break;
            case '742': 
                commercialItemsFiltred.value=supprimerDoublons(commercialItems.value.filter(el=>el.code&&el.code.match(/WOO/,'gmi')))
            break;
            case '737': 
                commercialItemsFiltred.value=supprimerDoublons(commercialItems.value.filter(el=>el.code&&el.code.match(/CAM/,'gmi')))
                 
            break;
        }
        if(store.state.user.groupe=='AGENT'){
            negoce.value.fournisseur.codeAgent=commercialItemsFiltred.value[0].code
            negoce.value.fournisseur.agent=commercialItemsFiltred.value[0].libelle
        }
       
    }
    let model=ref({type:'',item:{}})
   
    async  function sendCommandeNegoce(){
        let data = {
            ...negoce.value,
            fraisPort:fraisPort.value,
            code_marque:codeMarque.value} 
        if(store.state.user.groupe!='N'){
            data = {...negoce.value,
                fraisPort:fraisPort.value,
                user:store.state.user,
                code_marque:codeMarque.value
            } 
        }
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `https://my.edisac.com/api/commandes`,
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
            },
            data : data
        }
      
        return axios.request(config)
        .then((response) => { 
            authentification.value.type='create_order'
            if(model.value?.item?.token){
                commandeNotExist.value={exist:true,numero:response.data.numero,new:'new'}
                negocesCommandes.value.push({numero:response.data.numero,tiers:negoce.value.fournisseur.nomClient,saison:negoce.value.fournisseur.saison,token:response.data.token,code_marque:codeMarque.value})
                negocesCommandesFiltred.value.push({numero:response.data.numero,tiers:negoce.value.fournisseur.nomClient,saison:negoce.value.fournisseur.saison,token:response.data.token,code_marque:codeMarque.value})
                getCommandeNegoce(model.value.item.token)
            }else{
                getCommandeNegoce(negoce.value.token)
            }
            
            // negoce.value=response.data.donnes
            
        })
        .catch((error) => {
        //console.log(error);
        });
    }
    async  function getNegoceModeles(){
        // let data = {type:type,modele:modele} 
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: 'https://my.edisac.com/api/negocemodeles',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
            }
            // ,data : data
        }
      
        return axios.request(config)
        .then((response) => { 
            if(response){
                // newModele.value={
                //     marque:null,
                //      code_marque:null,
                //     saison:null,
                //     dialog:false
                // }
                itemsModele.value=response.data.modeles
                // console.log(itemsModele.value);
                
            }
        })
        .catch((error) => {
            if (error.response && error.response.status === 401) {
                // Token absent → rediriger vers login
                router.replace({ path: '/login' })
                // console.log('Non authentifié')
            } else if (error.response && error.response.status === 403) {
                // Token invalide/expiré → rediriger vers login
                router.replace({ path: '/login' })
                // console.log('Token invalide ou expiré')
            }
        });
    }
    async  function NegoceModeles(){
        let data = {newModele:newModele.value,user:store.state.user} 
       
        // console.log(model.value);
        
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `https://my.edisac.com/api/negocemodeles`,
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
            },
            data : data
        }
        if(authentification.value.type=='delete_model'){
            config={
                ...config,
                method:'delete',
                url: `https://my.edisac.com/api/negocemodeles/${model.value.item.numero}`,
                // params:{...model.value.item}
                data:model.value.item
                // newModele.value
            }
            
        }
        return axios.request(config)
        .then((response) => { 
            if(response){
                newModele.value={
                    marque:null,
                    saison:null,
                    dialog:false
                }
                itemsModele.value=response.data.modeles
            }
        })
        .catch((error) => {
            if (error.response && error.response.status === 401) {
                // Token absent → rediriger vers login
                router.replace({ path: '/login' })
                console.log('Non authentifié')
            } else if (error.response && error.response.status === 403) {
                // Token invalide/expiré → rediriger vers login
                router.replace({ path: '/login' })
                console.log('Token invalide ou expiré')
            }
        });
    }
    async function ExporterCommandeNegoce(){
        // console.log('negoce',negoce.value)
    }
    async  function EnvoyerCommandeNegoce(){
        dialogEmail.value=true
        let data = {...negoce.value,negoce:true}
            
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        // url: 'https://my.edisac.com/api/resendemail',
        url: 'https://my.edisac.com/api/resendemail',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
        },
        data : data
        }

        return axios.request(config)
        .then((response) => { 

        })
        .catch((error) => {
        //console.log(error);
        });
    }
    function checkingLogIn(){
        let data = JSON.stringify({
            "username": store.state.user.username,
            "password": mdpSaisie.value
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://my.edisac.com/api/login',
            headers: { 
                'Content-Type': 'application/json'
            },
            data : data
        };
        axios.request(config)
        .then((response) => {
            if(response.data.statut=='connected'){
                if(authentification.value.type=='validation'){
                    if(authentification.value.type=='edit_model'){
                        negoce.value.numero=null
                        negoce.value.file=null
                        sendCommandeNegoce()
                    }else{
                        sendCommandeNegoce()
                    }
                }else if(authentification.value.type=='delete_model'){
                    NegoceModeles(model.value.type,model.value.item)
                }else if(authentification.value.type=='add_model'){
                    setNewModeleNegoce()
                }else if(authentification.value.type=='edit_model'){
                    // NegoceModeles(model.value.type,model.value.item)
                    getCommandeNegoce(model.value.item.token)
                    codeMarque.value=model.value.item.code_marque
                    getArticles(Array.of(model.value.item.code_marque))
                }
                // validerProposition(fabricantToValidate.value)
                authentification.value.statut=false
            }else {
                message.value=`${response.data.name}, le mot de passe n'est pas correcte`
            }
            // console.log('authentification.value',authentification.value);
            // console.log('model.value',model.value);
        })
        .catch((error) => {
            //console.log(error);
        });
    }
    let statsTableFiltred=ref([])
    async function getStatsTiers(type,tiers){
        filtreSingleParams.value.gp_tiers=tiers
        axe.value={x:'gp_librepiece3',y:'gl_qtestock'};
        let url = `https://my.edisac.com/api/statistics/${type}`
        // let url = `https://my.edisac.com/api/statistics/${type}`
        let config = {
            method: 'post',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
            },
            url: url,
            data:filtreSingleParams.value
        }
        return axios.request(config)
            .then((response) => { 
                if(response.data.statsTable.length>0){
                    statsTable.value=response.data.statsTable
                    statsTableFiltred.value=statsTable.value
                    loading.value=false 
                    dialogueFiltreTiers.value=false
                    readyToExport.value=true
                    dialogStatsTiers.value=true;
                }else{
                    dialogErreur.value=true
                    loading.value=false 

                }
                 
            })
            .catch((error) => {
            //console.log(error)
            })
    
    }
    // FR51CAC372
    let negocesTable=ref([])
    let negocesTableFiltred=ref([])
    let waiting=ref(false)
    async function getNegocesTable(){
        let url = `https://my.edisac.com/api/getnegoces`
        waiting.value=true
        // let url = `https://my.edisac.com/api/getnegoces`
        let config = {
            method: 'get',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
            },
            url: url,
            params:filtre.value
        }
        return axios.request(config)
        .then((response) => { 
            negocesTable.value=response.data.negoces
            negocesTableFiltred.value=response.data.negoces
            waiting.value=false
        })
        .catch((error) => {
        })
    
    }
  
    async function getClients(){   
        let url=    `https://my.edisac.com/api/clients?etablissement=NEGO`
       
        let config = {
        method: 'get',
        url: url
        };
        return   axios.request(config)
        .then((response) => {

            itemsClient.value=response.data.map(x=>x={...x,t_title:`${x.t_tiers} - ${x.t_libelle}`,t_libelle_ville: `${x.t_libelle} - ${x.t_ville}`})
        })
        .catch((error) => {
        console.log(error);
        });

    }
    
    async function getAgents(){ 
        let url=    `https://my.edisac.com/api/agents`
        // let url=    `https://my.edisac.com/api/agents`
       
        let config = {
        method: 'get',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
        },
        url: url
        };
        return   axios.request(config)
        .then((response) => {
            commercialItems.value=response.data.map(x=>x={...x,title:`${x.libelle}`}) //.filter(el=>el.code_marque==codeMarque.value)

            commercialItemsFiltred.value=commercialItems.value
            getCommercial()
            // console.log(commercialItem.value);
            

            // response.data.filter(el=>el.code_marque==codeMarque.value).map(x=>x={...x,title:`${x.libelle} - ${x.marque}`})
        })
        .catch((error) => {
        //console.log(error);
        });

    }
    // import * as XLSX from 'xlsx'
    // State
    const fileInput = ref(null)
    const isLoading = ref(false)
    const processedItems = ref(0)
    const totalItems = ref(0)
    const results = ref([])
    const errors = ref([])

    // Methods
    const triggerFileInput = () => {
        fileInput.value.click()
        }
    const handleFileUpload = async (event) => {
        const file = event.target.files[0]
        if (!file) return

        try {
            isLoading.value = true
            results.value = []
            errors.value = []
            processedItems.value = 0

            const data = await readExcelFile(file)
            const eanList = extractEAN13(data)
            
            if (eanList.length === 0) {
            alert('Aucun EAN13 trouvé dans l\'onglet EXPORT')
            return
            }

            totalItems.value = eanList.length
            await processEANList(eanList)

        } catch (error) {
            console.error('Erreur lors du traitement du fichier:', error)
            alert('Erreur lors de la lecture du fichier: ' + error.message)
        } finally {
            isLoading.value = false
            // Reset file input
            event.target.value = ''
        }
    }

    const readExcelFile = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            
            reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result)
                const workbook = XLSX.read(data, { type: 'array' })
                
                // Find the EXPORT sheet
                let sheet = null
                let sheetName = ''
                
                // Try to find sheet named "EXPORT"
                if (workbook.SheetNames.includes('EXPORT')) {
                sheetName = 'EXPORT'
                sheet = workbook.Sheets['EXPORT']
                } else {
                // If no EXPORT sheet, use the first sheet
                sheetName = workbook.SheetNames[0]
                sheet = workbook.Sheets[sheetName]
                console.warn(`Aucun onglet "EXPORT" trouvé, utilisation de "${sheetName}"`)
                }
                
                const jsonData = XLSX.utils.sheet_to_json(sheet)
                resolve(jsonData)
            } catch (error) {
                reject(new Error('Erreur lors de la lecture du fichier: ' + error.message))
            }
            }
            
            reader.onerror = () => {
            reject(new Error('Erreur lors de la lecture du fichier'))
            }
            
            reader.readAsArrayBuffer(file)
        })
    }

    const extractEAN13 = (data) => {
        const eans = []
        
        // Chercher la colonne EAN13 (différentes variantes possibles)
        const eanColumns = ['EAN13', 'ean13', 'EAN', 'EAN-13', 'ean', 'Code EAN', 'codeEAN']
        
        data.forEach(row => {
            let ean = null
            
            // Chercher dans les colonnes possibles
            for (const col of eanColumns) {
            if (row[col] !== undefined && row[col] !== null && row[col] !== '') {
                ean = String(row[col]).trim()
                break
            }
            }
            
            // Si rien trouvé, chercher dans toutes les colonnes
            if (!ean) {
            for (const key in row) {
                const value = String(row[key]).trim()
                // Vérifier si c'est un EAN13 (13 chiffres)
                if (/^\d{13}$/.test(value)) {
                ean = value
                break
                }
            }
            }
            
            if (ean && /^\d{13}$/.test(ean)) {
            eans.push(ean)
            }
        })
        
        return eans
    }

    const processEANList = async (eanList) => {
        const batchSize = 5 // Traiter par lots pour éviter de surcharger l'API
        
        for (let i = 0; i < eanList.length; i += batchSize) {
            const batch = eanList.slice(i, i + batchSize)
            const promises = batch.map(ean => processSingleEAN(ean))
            await Promise.allSettled(promises)
        }
    }

    const processSingleEAN = async (ean) => {
        try {
            const article = await getArticle(ean)
            
            results.value.push({
            ean,
            article,
            error: null,
            timestamp: new Date().toISOString()
            })
            
        } catch (error) {
            console.error(`Erreur pour l'EAN ${ean}:`, error)
            
            results.value.push({
            ean,
            article: null,
            error: error.message || 'Erreur lors de la récupération de l\'article',
            timestamp: new Date().toISOString()
            })
            
        } finally {
            processedItems.value++
        }
    }
    function supprimerDoublons(tableau) {
        const vus = new Set();
        return tableau.filter(item => {
            const cle = `${item.code}|${item.libelle}`;
            if (vus.has(cle)) return false;
            vus.add(cle);
            return true;
        });
    }
    let commercialItemsFiltred=ref([])
    async function getCommercial(){
        if(store.state.user.groupe=='AGENT'){
            // console.log('commercialItem.value',commercialItems.value);
            let lib = commercialItems.value.find(el=>el.code==store.state.user.username.toUpperCase())
            // console.log('lib',lib);
            // console.log('commercialItem.value',commercialItems.value);
            commercialItems.value=commercialItems.value.filter(el=>el.libelle.trim().toUpperCase()==lib.libelle.trim().toUpperCase())
            // console.log('commercialItem.value',commercialItems.value);
            commercialItemsFiltred.value=commercialItems.value
        }
    }
    // Export results to CSV
    const exportToCSV = () => {
    if (results.value.length === 0) return
    
    const headers = ['EAN13', 'Nom', 'Prix', 'Stock', 'Statut']
    const csvData = results.value.map(result => [
        result.ean,
        result.article ? result.article.nom : '',
        result.article ? result.article.prix : '',
        result.article ? result.article.stock : '',
        result.error ? 'Erreur' : 'Succès'
    ])
    
    const csvContent = [
        headers.join(','),
        ...csvData.map(row => row.join(','))
    ].join('\n')
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', `resultats_articles_${new Date().toISOString().slice(0,10)}.csv`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
    }

    const clearResults = () => {
    results.value = []
    errors.value = []
    processedItems.value = 0
    totalItems.value = 0
    }
    onBeforeRouteUpdate((to, from) => {
        loadParams()
    })
    onMounted(()=>{
        loadParams()
        if(store.state.user.groupe!='N'){
            // getArticles(['731'])
            getClients()
            getAgents()
            getNegoceModeles()
            getCommandesNegoces()
        }
       
        // getCommercial()
    })
    
</script>
<style>
.v-expansion-panel-title{
   height: 10px; 
}
.chart-container {
  width: 600px;    /* Largeur souhaitée */
  height: 100px;   /* Hauteur souhaitée */
  position: relative;
}

.scroll-box {
  height: 300px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 16px;
}
.iconAdd{
cursor: pointer;
}
.iconAdd:hover{
background-color: orange;
}
.entete.sticky {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 2;
}

/*  */
.currency-input-container {
  position: relative;
  display: inline-block;
  max-width: 300px;
  width: 100%;
}

.modern-currency-input {
  width: 100%;
  padding: 1px 45px 1px 20px;
  border: 2px solid #e1e8ed;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 500;
  background-color: #ffffff;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: right;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: #1a1a1a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.modern-currency-input:focus {
  outline: none;
  border-color: #0066ff;
  box-shadow: 0 4px 16px rgba(0, 102, 255, 0.15);
  transform: translateY(-1px);
}

.modern-currency-input:hover {
  border-color: #b3c7d9;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.modern-currency-input::placeholder {
  color: #9aa6b8;
  font-weight: 400;
}

.currency-symbol {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-weight: 600;
  color: #66758a;
  font-size: 18px;
  pointer-events: none;
  transition: color 0.3s ease;
}

.modern-currency-input:focus + .currency-symbol {
  color: #0066ff;
}

/* États de validation */
.modern-currency-input:valid {
  border-color: #00c853;
}

.modern-currency-input:invalid:not(:placeholder-shown) {
  border-color: #ff4444;
}
.actions-card {
  margin-top: 20px;
}
.chart-container {
  width: 900px;    /* Largeur souhaitée */
  height: 400px;   /* Hauteur souhaitée */
  position: relative;
}
.chart-container-pie {
  width: 1000px;    /* Largeur souhaitée */
  height: 400px;   /* Hauteur souhaitée */
  position: relative;
}
.chart-container-bar {
  width: 1000px;    /* Largeur souhaitée */
  height: 400px;   /* Hauteur souhaitée */
  position: relative;
}
.upload-section {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}
.bloc-ref {
  content-visibility: auto;
  contain-intrinsic-size: auto 250px; /* hauteur approximative d'une référence */
}
.btn-upload {
  padding: 10px 20px;
  background: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}
.elevation-red {
  box-shadow: 0 10px 20px rgba(255, 0, 0, 0.4) !important;
}

.elevation-green {
  box-shadow: 0 10px 20px rgba(0, 255, 0, 0.4) !important;
}

.elevation-grey {
  box-shadow: 0 10px 20px rgba(128, 128, 128, 0.4) !important;
}
/*  */
</style>